const SW = {
  '1': 'Januari',
  '2': 'Februari',
  '3': 'Machi',
  '4': 'Aprili',
  '5': 'Mei',
  '6': 'Juni',
  '7': 'Julai',
  '8': 'Agosti',
  '9': 'Septemba',
  '10': 'Oktoba',
  '11': 'Novemba',
  '12': 'Desemba',
  'Admob_text7': 'Katika maandalizi',
  'Admob_text8': 'Video bado haiko tayari',
  'AnchorCenter_biList_interaction_Popup1': 'Ulipokea ujumbe kutoka kwa watumiaji \'x\'',
  'AnchorCenter_biList_interaction_Popup10': 'Mfano: Ulituma ujumbe kwa watumiaji 100, na 50 kati yao walijibu. Kiwango chako cha majibu bora (UV) = 50/100 = 50%',
  'AnchorCenter_biList_interaction_Popup11': 'Kiwango Bora cha Majibu: Inahesabu tu majibu yaliyopokelewa kabla ya kumalizika muda',
  'AnchorCenter_biList_interaction_Popup12': 'Ulituma ujumbe \'x\'',
  'AnchorCenter_biList_interaction_Popup13': 'Kati ya ujumbe \'x\' uliopeleka, \'n\' ulijibiwa kwa ufanisi',
  'AnchorCenter_biList_interaction_Popup14': 'Asilimia ya Ujumbe Wako Uliojibiwa (PV)',
  'AnchorCenter_biList_interaction_Popup15': 'Mfano: Ulituma ujumbe 100, na 70 kati yao ulijibiwa kwa ufanisi. Kiwango chako cha majibu bora (PV) = 70/100 = 70%',
  'AnchorCenter_biList_interaction_Popup16': 'Kiwango Bora cha Majibu: Inahesabu tu majibu yaliyopokelewa kabla ya kumalizika muda',
  'AnchorCenter_biList_interaction_Popup2': 'Ulijibu \'n\' kati ya \'x\' watumiaji waliokutumia ujumbe',
  'AnchorCenter_biList_interaction_Popup3': 'Mfano: Ulipokea ujumbe kutoka kwa watumiaji 100, na ulijibu kwa ufanisi 90 kati yao. Kiwango chako cha majibu bora (UV) = 90/100 = 90%',
  'AnchorCenter_biList_interaction_Popup4': 'Asilimia ya Ujumbe Uliojibiwa (UV)',
  'AnchorCenter_biList_interaction_Popup5': 'Kiwango Bora cha Majibu: Inahesabu tu watumiaji waliopokea majibu kabla ya kumalizika muda',
  'AnchorCenter_biList_interaction_Popup6': 'Nimepata',
  'AnchorCenter_biList_interaction_Popup7': 'Ulituma ujumbe kwa watumiaji \'x\'',
  'AnchorCenter_biList_interaction_Popup8': 'Kati ya watumiaji \'x\' uliowatuma ujumbe, \'n\' walikujibu',
  'AnchorCenter_biList_interaction_Popup9': 'Asilimia ya Watumiaji Waliojibu (UV)',
  'AnchorCenter_biList_interaction_text1': 'Mwingiliano',
  'AnchorCenter_biList_interaction_text10': 'Ujumbe Wako Uliojibiwa (UV)',
  'AnchorCenter_biList_interaction_text11': 'Kiwango cha Majibu (UV)',
  'AnchorCenter_biList_interaction_text12': 'Ujumbe Uliotumwa (PV)',
  'AnchorCenter_biList_interaction_text13': 'Ujumbe Wako Uliojibiwa (PV)',
  'AnchorCenter_biList_interaction_text14': 'Kiwango cha Majibu (PV)',
  'AnchorCenter_biList_interaction_text2': 'Mazungumzo Yaliyoanzishwa (UV)',
  'AnchorCenter_biList_interaction_text3': 'Kiwango cha Majibu (UV)',
  'AnchorCenter_biList_interaction_text4': 'Kiwango cha Majibu (PV)',
  'AnchorCenter_biList_interaction_text5': 'Kiwango cha Majibu (UV)',
  'AnchorCenter_biList_interaction_text6': 'Ujumbe Uliofika (UV)',
  'AnchorCenter_biList_interaction_text7': 'Ujumbe Uliojibiwa (UV)',
  'AnchorCenter_biList_interaction_text8': 'Kiwango cha Majibu (UV)',
  'AnchorCenter_biList_interaction_text9': 'Ujumbe Uliotumwa (UV)',
  'Anonymity_name': 'Usiri',
  'Charge_Same_1': 'Umetuma kiasi sawa cha malipo kwa mtumiaji huyu hivi karibuni na muamala ulikuwa wa mafanikio. Je, unataka kuendelea tena?',
  'Charge_Same_2': 'Ghairi Malipo',
  'Charge_Same_3': 'Endelea na Malipo',
  'Double_Rewards_text1': 'Kuwa SVIP kwa Zawadi Mara Mbili!',
  'EXP': 'EXP',
  'Experience_Card_Statement': '*Kadi za uzoefu hazina faida hii',
  'Hate': 'Chuki',
  'Noble_Change_2': 'Masharti ya Kununua: Cheo cha chini kinaweza kununua cheo cha juu, lakini cheo cha juu hakiwezi kununua cheo cha chini. Kwa mfano, ikiwa kwa sasa wewe ni Count, unaweza kununua tu Marquis, Duke, au King.',
  'Noble_Change_3': 'Mantiki ya Ubadilishaji: Ikiwa tayari wewe ni aristocrat, baada ya kununua cheo kingine cha aristocrat, kipindi kilichobaki cha uhalali wa cheo cha zamani cha aristocrat kitabadilishwa kuwa cheo kipya cha aristocrat kulingana na uwiano wa bei ya sarafu, na cheo cha zamani cha aristocrat kitakuwa batili.',
  'Noble_Change_4': 'Uhalali wa Kipindi cha Uhalali: Kipindi kipya cha uhalali wa aristocracy kilichonunuliwa = siku za cheo cha sasa cha aristocrat kilichobaki * (bei ya cheo cha sasa cha aristocrat / bei ya cheo cha aristocrat kilichonunuliwa) + 30, idadi ya mwisho ya siku imekatwa.',
  'Noble_Change_5': 'Mfano: Ikiwa kwa sasa wewe ni Viscount (99990 sarafu/mwezi), ukiwa na siku 13 zilizobaki, na unununua Count (199990sarafu/mwezi) leo, basi baada ya malipo, kipindi cha uhalali wa Count kitakuwa 13 * (99990/199990) + 30 = 6.5 imekatwa + 30 = siku 36.',
  'OfficialTaskPic_Level_text1': 'Zawadi za Mapato ya Almasi ya Kila Siku (Ujumbe wa IM)',
  'OfficialTaskPic_Level_text10': 'Zawadi ya Almasi',
  'OfficialTaskPic_Level_text11': 'Ilani:',
  'OfficialTaskPic_Level_text12': '1. Zawadi ya chumba cha sauti: ikiwa ni pamoja na chumba cha kawaida cha sauti na chumba cha familia cha sauti;',
  'OfficialTaskPic_Level_text13': '2. Kipindi cha kazi cha zawadi ya shughuli: Baada ya kipindi kumalizika, idadi ya siku za shughuli itahesabiwa, na zawadi ya juu zaidi unayoweza kupata ni almasi 350;',
  'OfficialTaskPic_Level_text14': '3. Zawadi zote za almasi zitatumwa moja kwa moja kwenye akaunti yako wakati wa kipindi hiki cha kazi;',
  'OfficialTaskPic_Level_text15': '4. Kila almasi 100 = 1 USD',
  'OfficialTaskPic_Level_text16': 'Zawadi ya kila siku (kwa zawadi katika mazungumzo, simu za sauti na video, mechi ya sauti)',
  'OfficialTaskPic_Level_text17': 'Ikiwa unapokea almasi kwa zawadi katika mazungumzo, simu za sauti na video, mechi ya sauti na kufikia lengo la kila siku, utapokea zawadi ya almasi inayolingana. Zawadi za almasi zitaongezwa kwenye akaunti yako siku inayofuata moja kwa moja.',
  'OfficialTaskPic_Level_text18': 'Zawadi ya kila siku (kwa zawadi katika mazungumzo na vyumba vya sauti)',
  'OfficialTaskPic_Level_text19': 'Zawadi ya Kipindi cha Kazi (kwa simu za sauti na video)',
  'OfficialTaskPic_Level_text2': 'Kiwango',
  'OfficialTaskPic_Level_text20': '1. Ikiwa unapokea almasi kwa zawadi katika mazungumzo na vyumba vya sauti na kufikia lengo la kila siku, utapokea zawadi ya almasi inayolingana. Zawadi za almasi zitaongezwa kwenye akaunti yako siku inayofuata moja kwa moja.',
  'OfficialTaskPic_Level_text21': '2. Ikiwa unapokea almasi kwa simu za sauti na video na kufikia lengo mwishoni mwa kipindi cha kazi, utapokea zawadi ya almasi inayolingana. Zawadi za almasi zitaongezwa kwenye akaunti yako siku inayofuata baada ya kumalizika kwa kipindi cha kazi moja kwa moja.',
  'OfficialTaskPic_Level_text22': '3. Kuna vipindi 2 vya kazi vinavyoanza kutoka tarehe 1 hadi 15 ya kila mwezi, na kutoka tarehe 16 hadi 30/31 ya kila mwezi.',
  'OfficialTaskPic_Level_text23': 'Zawadi ya kila siku 1 (Chumba cha Sherehe za Sauti & Zawadi ya Almasi ya Familia)',
  'OfficialTaskPic_Level_text24': 'Zawadi ya kila siku 2 (Simu ya Sauti, Mechi ya Sauti ya Almasi)',
  'OfficialTaskPic_Level_text25': 'Zawadi ya Kipindi cha Kazi (Mazungumzo, Chumba cha Sherehe za Sauti, Simu za Sauti, Mechi ya Sauti)',
  'OfficialTaskPic_Level_text26': '1. Ikiwa unapokea almasi kwa zawadi katika mazungumzo, chumba cha sauti na simu za video, mechi ya sauti na kufikia lengo la kila wiki, utapokea zawadi ya almasi inayolingana. Zawadi za almasi zitaongezwa kwenye akaunti yako katika kipindi hiki cha mshahara moja kwa moja.',
  'OfficialTaskPic_Level_text27': '2. Kiwango cha Mshahara: 100 Almasi=1 USD;',
  'OfficialTaskPic_Level_text28': '3. Almasi zilizopatikana kutoka kwa zawadi za kila siku hazitahesabiwa kwa lengo hili la almasi;',
  'OfficialTaskPic_Level_text29': 'Mfumo rasmi wa zawadi wa Soyou 02.2024',
  'OfficialTaskPic_Level_text3': 'Lengo la Almasi',
  'OfficialTaskPic_Level_text30': 'Kazi ya kila siku 1: Simu zote + zawadi zote',
  'OfficialTaskPic_Level_text31': 'Kazi ya Kila Siku 2: Kujibu Ujumbe',
  'OfficialTaskPic_Level_text32': 'Lengo la Almasi la Kila Siku',
  'OfficialTaskPic_Level_text33': 'Lengo letu la almasi la kila siku linaonyeshwa hapo juu, na siku moja katika mfumo wetu wa zawadi inategemea wakati wa ndani wa Uturuki.',
  'OfficialTaskPic_Level_text4': 'Zawadi ya Almasi',
  'OfficialTaskPic_Level_text5': 'Zawadi za Mapato ya Almasi ya Kila Siku (Zawadi za chumba cha sauti: chumba cha kawaida cha sauti + chumba cha familia cha sauti)',
  'OfficialTaskPic_Level_text6': 'Zawadi za Mapato ya Almasi za Kipindi cha Kazi (Ujumbe wa IM + zawadi zote zilizopokelewa)',
  'OfficialTaskPic_Level_text7': 'Zawadi za Shughuli za Kipindi cha Kazi',
  'OfficialTaskPic_Level_text8': 'Ingia kwa siku {%s1} na upate almasi {%s2} kila siku',
  'OfficialTaskPic_Level_text9': 'Mahitaji',
  'OfficialTask_ActiveCard_text1': 'Zawadi ya shughuli ya kipindi cha kazi',
  'OfficialTask_ActiveCard_text2': 'Kuingia kwa jumla katika mzunguko {%s1} siku ({%s2}/{%s3})',
  'OfficialTask_ActiveCard_text3': 'Ikiwa mapato ya kila siku ya almasi yanafikia {%s1} 💎, na unaweza kupata {%s2} 💎. (Leo: {%s3}/{%s4})',
  'OfficialTask_Card_common_text1': 'Kazi Rasmi',
  'OfficialTask_Card_common_text2': 'Baada ya kukamilisha kazi rasmi ya zawadi, unaweza kupata almasi {%s} kwa kiwango cha juu!',
  'OfficialTask_PeriodCard_text1': 'Zawadi ya Almasi ya Kipindi cha Kazi ({%s1}/{%s2})',
  'OfficialTask_PeriodCard_text2': 'Zawadi ya almasi ya kipindi cha kazi ({%s3}) inafikia {%s1} 💎, pata {%s2} 💎',
  'OfficialTask_dailyCard_text1': 'Zawadi za mapato ya almasi za kila siku ({%s1}/{%s2})',
  'OfficialTask_dailyCard_text2': 'Mapato ya almasi ya kila siku ({%s1}) yanafikia {%s2} 💎, pata {%s3} 💎',
  'OfficialTask_dailyCard_text3': 'Zawadi za mapato ya almasi za kila siku ({%s3}) zinafikia {%s1} 💎, pata {%s2} 💎',
  'OfficialTask_dailyCard_text4': 'Muda wa Zawadi',
  'OfficialTask_dailyCard_text5': 'Nenda',
  'OfficialTask_dailyCard_text6': 'Imekamilika',
  'OfficialTask_rewardTime_text1': 'saa',
  'OfficialTask_rewardTime_text2': 'dakika',
  'Official_website_payment_1': 'Malipo ya Mtandaoni ya Soyou',
  'Official_website_payment_10': '3. Muamala wowote nje ya mtandao hauungwi mkono.',
  'Official_website_payment_11': '4. Usifichue taarifa za akaunti yako kwa mtu mwingine kwa sababu yoyote au kwa njia yoyote.',
  'Official_website_payment_12': '5. Soyou haitawajibika kwa mizozo yoyote kati ya Watumiaji na mtu wa tatu.',
  'Official_website_payment_13': '6. Ikiwa kuna tatizo lolote na malipo, tafadhali wasiliana na huduma kwa wateja au tuandikie barua pepe.',
  'Official_website_payment_14': 'Kuzuia Utakatishaji Fedha',
  'Official_website_payment_15': '1. Mtumiaji lazima ahakikishe kuwa una utambulisho halali na uwezo wa kutumia huduma zinazotolewa na sisi na hautashiriki au kuhusishwa na shughuli yoyote ya kihalifu.',
  'Official_website_payment_16': '2. Akaunti ya mtumiaji ni kwa matumizi yako pekee na ni yako peke yako. Huwezi kuhamisha, kukodisha au vinginevyo kutoa akaunti yako kwa mtu wa tatu.',
  'Official_website_payment_17': '3. Mtumiaji lazima ahakikishe kuwa pesa zote zinazotumika kwa malipo zinapatikana kwa njia halali na hazihusiani wakati wowote na shughuli au tabia ya kihalifu.',
  'Official_website_payment_18': 'Njia ya Malipo',
  'Official_website_payment_19': 'Hivi sasa tunatumia njia ya malipo ya {%s}',
  'Official_website_payment_2': 'ID ya Malipo',
  'Official_website_payment_20': 'Chaguo la Malipo',
  'Official_website_payment_21': 'Badilisha',
  'Official_website_payment_22': 'ID ya akaunti haipo!',
  'Official_website_payment_23': 'Hakuna njia za malipo zilizoungwa mkono bado',
  'Official_website_payment_24': 'Toa maoni yako ya njia ya malipo inayohitajika',
  'Official_website_payment_25': 'Kuulizia matokeo ya muamala',
  'Official_website_payment_26': 'Matokeo ya malipo yanapaswa kuthibitishwa',
  'Official_website_payment_27': 'Matokeo ya malipo yanaweza kucheleweshwa. Tafadhali ingia kwenye App kuangalia rekodi ya malipo ya akaunti. Ikiwa akaunti haijafika kwa muda mrefu, tafadhali wasiliana na huduma kwa wateja.',
  'Official_website_payment_28': 'Sasisha',
  'Official_website_payment_29': 'Malipo yalishindikana',
  'Official_website_payment_3': 'Ingiza ID',
  'Official_website_payment_30': 'Taarifa ya msaada:',
  'Official_website_payment_31': '1. Tafadhali thibitisha kama kiasi na njia ya malipo ni sahihi, ikiwa ni pamoja na taarifa za kibinafsi, namba ya kadi ya mkopo, kipindi cha uhalali, nambari ya CVV, nk.',
  'Official_website_payment_32': '2. Tafadhali angalia kama salio la akaunti linatosha.',
  'Official_website_payment_33': '3. Angalia kama muunganisho wa mtandao ni thabiti. Wakati mwingine matatizo ya mtandao yanaweza kusababisha kushindwa kwa malipo.',
  'Official_website_payment_34': '4. Jaribu kubadilisha njia nyingine za malipo au jaribu kulipa baadaye.',
  'Official_website_payment_35': '5. Ikiwa tatizo bado halijatatuliwa, inashauriwa kuwasiliana na huduma kwa wateja wa jukwaa la malipo kwa msaada zaidi.',
  'Official_website_payment_36': 'Malipo ya mafanikio',
  'Official_website_payment_37': 'Tafadhali ingia kwenye App ili kuona rekodi ya malipo ya akaunti',
  'Official_website_payment_38': 'Kiungo cha muda kimefeli',
  'Official_website_payment_39': 'Kiungo kimekwisha muda. Tafadhali tengeneza tena kiungo cha malipo kwenye App.',
  'Official_website_payment_4': 'ID ni nini?',
  'Official_website_payment_5': 'Tafadhali angalia kwanza ili kulinda faragha na usalama wa akaunti.',
  'Official_website_payment_6': 'Kuuliza',
  'Official_website_payment_7': 'Ilani kwa Watumiaji',
  'Official_website_payment_8': '1. Usinunue sarafu za Soyou kupitia tovuti zisizo rasmi au zisizoidhinishwa ili kuepuka mizozo isiyo ya lazima.',
  'Official_website_payment_9': '2. Usiamini taarifa yoyote isiyo rasmi iliyochapishwa kwenye tovuti nyingine, njia za mawasiliano au vikundi vya mawasiliano. Taarifa zote za tukio zinategemea tangazo rasmi kupitia tovuti rasmi au ilani ya mfumo.',
  'Privacy Policy': 'Sera ya Faragha',
  'Registr_optimization_1': 'Masuala ya Usajili na Kuingia',
  'Terms of Service': 'Masharti ya Huduma',
  'Tvwall_gift_10': 'Masharti ya skrini ya kufuli ya kuingia:',
  'Tvwall_gift_11': 'Funga skrini kwa sekunde 10: zawadi ya kutamani imekamilika na thamani ya zawadi ya kutamani ni kati ya sarafu 2000 na sarafu 9999;',
  'Tvwall_gift_12': 'Funga skrini kwa sekunde 20: Zawadi ya kutamani imekamilika na thamani ya zawadi ya kutamani ni kati ya sarafu 10,000 na sarafu 49,999;',
  'Tvwall_gift_13': 'Funga skrini kwa sekunde 60: Zawadi ya kutamani imekamilika na thamani ya zawadi ya kutamani ni zaidi ya sarafu 50,000',
  'Tvwall_gift_14': 'Masharti ya kuonekana kwenye Ukuta wa Televisheni ya Dunia:',
  'Tvwall_gift_15': 'Rekodi ya kawaida: Zawadi ya kutamani imekamilika na thamani ya zawadi ya kutamani ni kati ya sarafu 2000 na sarafu 9999',
  'Tvwall_gift_16': 'Rekodi ya kifahari: Zawadi ya kutamani imekamilika na thamani ya zawadi ya kutamani ni sawa na au zaidi ya sarafu 10,000',
  'Tvwall_gift_17': 'Kwenye ukuta wa TV',
  'Tvwall_gift_18': 'Anonimasi kwenye ukuta wa TV',
  'Tvwall_gift_19': 'Sio kwenye ukuta wa TV',
  'Tvwall_gift_32': 'Je, kutoa zawadi kuonyeshwe kwenye TV?',
  'Tvwall_gift_33': '(Bonyeza ili kuchagua kutekeleza mara moja)',
  'Tvwall_gift_9': 'Kamilisha orodha za matakwa ya zawadi yenye thamani zaidi ya au sawa na sarafu 2,000 kuonyeshwa kwenye ukuta wa TV',
  'about.badges.0': 'Vaa Beji',
  'about.badges.1': 'Beji zote zinaweza kuvaliwa, na hadi beji tano zinaweza kuvaliwa kwa wakati mmoja.',
  'about.badges.2': 'Beji ya Heshima',
  'about.badges.3': 'Beji zilizofunguliwa na maadili ya kila mwezi yaliyokusanywa zinahesabiwa tarehe 1 ya kila mwezi ikiwa zinamilikiwa au la. Kipindi cha uhalali hudumu kwa mwezi mmoja.',
  'about.badges.title': 'Kuhusu Beji',
  'activity.gift.list.contributor': 'Uwezo wa Wachambua',
  'activity.gift.list.receive': 'Nyota',
  'activity.gift.list.send': 'Wachambua',
  'activity.gift.list.stars': 'Mwenendo wa Nyota',
  'all': 'Zote',
  'anchor.pk.PK.Times': 'Nyakati za PK',
  'anchor.pk.coins': 'Sarafu',
  'anchor.pk.countdown': 'Kipindi cha kuhesabu',
  'anchor.pk.daily.Ranking': 'Orodha ya Kila Siku',
  'anchor.pk.days': 'Siku',
  'anchor.pk.duration': 'Muda',
  'anchor.pk.event.end': 'Tukio limeisha',
  'anchor.pk.exclusive.Sponsor': 'Mdhamini wa Kipekee',
  'anchor.pk.hours': 'Saa',
  'anchor.pk.minutes': 'Dakika',
  'anchor.pk.queen': 'Malkia wa Haiba',
  'anchor.pk.queen.daily.rewards': 'Zawadi za Orodha ya Kila Siku ya Malkia wa Haiba',
  'anchor.pk.queen.total.rewards': 'Zawadi za Orodha ya Jumla ya Malkia wa Haiba',
  'anchor.pk.rank': 'Cheo',
  'anchor.pk.rewards': 'Zawadi',
  'anchor.pk.rules': 'Sheria',
  'anchor.pk.rules.rewards': 'Sheria&Zawadi',
  'anchor.pk.seconds': 'Sekunde',
  'anchor.pk.sponsor': 'Mdhamini wa Kipekee wa Leo',
  'anchor.pk.sponsor.daily.rewards': 'Zawadi za Orodha ya Kila Siku ya Mdhamini wa Kipekee',
  'anchor.pk.sponsor.total.rewards': 'Zawadi za Orodha ya Jumla ya Mdhamini wa Kipekee',
  'anchor.pk.target': 'Lengo',
  'anchor.pk.tools.rewards': 'Zana Zawadi',
  'anchor.pk.total.Ranking': 'Orodha ya Jumla',
  'anchor.pk.win.Times': 'Shinda Nyakati',
  'anchor_task_txt1': 'Tembelea marafiki wa zamani (na upate majibu kutoka kwao) kwa {%s1} mara na upate {%s2} 💎',
  'anchor_task_txt2': 'Idadi ya vipindi na watumiaji wapya > 5 inafikia {%s1} mara, pata {%s2} 💎',
  'anniversary.celebration.2.collect': 'Kusanya',
  'anniversary.celebration.2.go.look': 'Angalia sasa!',
  'anniversary.celebration.2.next.round': 'Mzunguko ujao',
  'anniversary.celebration.2.no.time.yet': 'Bado sio wakati',
  'anniversary.celebration.2.ok': 'Sawa',
  'anniversary.celebration.2.ranking.tab.receive': 'Orodha ya Haiba',
  'anniversary.celebration.2.ranking.tab.send': 'Orodha ya Utajiri',
  'anniversary.celebration.2.rewards.tips': 'Kwa maelezo kuhusu kupata Sarafu na Almasi, tafadhali angalia ukurasa wa sheria.',
  'anniversary.celebration.2.scene.rewards.desc': 'Baada ya kushiriki katika kufungua eneo la sasa, unaweza kupata zawadi zifuatazo, na MVP ina zawadi za ziada.',
  'anniversary.celebration.2.scene.tips': 'Matumizi ya sarafu za majukwaa yote (isipokuwa sehemu ya mchezo&kutuma kifurushi cha bahati) yanafikia thamani lengwa kufungua mandhari kupata zawadi. Kutuma zawadi zilizopunguzwa kunaweza kupata pointi maradufu!',
  'anniversary.celebration.2.scene.unlock.modal.mvp.tag': 'MVP inaweza kupata',
  'anniversary.celebration.2.scene.unlock.modal.title': 'Hongera kwa ushiriki wako katika kufungua eneo:',
  'anniversary.celebration.2.scene.unlock.modal.you.can.get': 'Inaweza kupata',
  'anniversary.celebration.2.special.gift.contribution': 'Sanduku la Haiba',
  'anniversary.celebration.2.special.gift.desc': 'Thamani ya jumla ya zawadi iliyopokelewa {%d} sarafu inaweza kushiriki katika kuchagua nyota wa bahati ({%z}/{%m})',
  'anniversary.celebration.2.special.gift.lucky': 'Sanduku la Bahati',
  'anniversary.celebration.2.special.gift.title': 'Sanduku la Bonasi',
  'anniversary.celebration.2.special.gift.to.be.drawn': 'Kuchora',
  'anniversary.celebration.2.special.gift.to.complete': 'Kamilisha sasa',
  'anniversary.celebration.2.tab.ranking': 'Orodha',
  'anniversary.celebration.2.tab.scene': 'Safari ya Sherehe',
  'anniversary.celebration.2.waiting': 'inasubiri',
  'annual.draw.1.time': 'Chora {N} mara',
  'annual.draw.10.time': 'Chora {N} mara',
  'annual.draw.pop.no.record': 'Hakuna rekodi bado.',
  'annual.draw.pop.no.times': 'Muda wa kuchora hautoshi',
  'annual.draw.pop.oppos': 'Oppos!',
  'annual.draw.pop.rewards.title': 'Hongera!',
  'annual.draw.pop.to.get': 'KUPATA',
  'annual.draw.record.text': 'Hongera! Umepewa',
  'annual.ranking.collect': 'Kusanya',
  'annual.ranking.confirm': 'Thibitisha',
  'annual.ranking.current.tickets': 'Tiketi za Sasa',
  'annual.ranking.daily.ranking': 'Orodha ya Kila Siku',
  'annual.ranking.daily.task': 'Kazi ya Kila Siku',
  'annual.ranking.exchange': 'Badilisha',
  'annual.ranking.exchange.amount': 'Kiasi cha kubadilisha',
  'annual.ranking.exchange.maximum': 'Kiasi cha kubadilisha kimefikia kiwango cha juu leo',
  'annual.ranking.fortune.wheel': 'Gurudumu la Bahati',
  'annual.ranking.icon': 'Ikoni',
  'annual.ranking.limited': 'Imewekwa',
  'annual.ranking.num': 'Nambari',
  'annual.ranking.open': 'Fungua',
  'annual.ranking.points': 'Pointi',
  'annual.ranking.record': 'Rekodi',
  'annual.ranking.return': 'Rudi',
  'annual.ranking.slod.out': 'IMEUZWA',
  'annual.ranking.stock': 'Hisa',
  'annual.ranking.success': 'Mafanikio',
  'annual.ranking.surprise.store': 'Duka la Kushangaza',
  'annual.ranking.task.confirm': 'Una uhakika wa kufurahia pointi {$count}x sasa?',
  'annual.ranking.ticket': 'Tiketi',
  'annual.ranking.to.bag': 'Bidhaa zilizobadilishwa zinaweza kuonekana kwenye mfuko',
  'annual.ranking.total.ranking': 'Orodha ya Jumla',
  'annual.ranking.unfinished': 'Haijakamilika',
  'annual.ranking.union.achor': 'Mshiriki wa Mwaka',
  'annual.ranking.union.agency': 'Shirika la Mwaka',
  'annual.ranking.union.id': 'Kitambulisho cha Shirika:',
  'annual.ranking.union.target': 'Lengo',
  'aristocracy.vip.coin.box.sub.title': 'Inatumika hadi',
  'aristocracy.vip.title': 'Uaristokrasia',
  'biu.biu.building.all.list': 'Orodha ya Jumla',
  'biu.biu.building.can.rush.one': 'Nyakati Zilizobaki za Haraka: Gari la Kiwango1*{$times}',
  'biu.biu.building.can.rush.two': 'Gari la Kiwango2*{$times}',
  'biu.biu.building.car.detail': 'Maelezo ya Gari',
  'biu.biu.building.car.double': 'Magari',
  'biu.biu.building.car.not.enough': 'Idadi ya sasa ya magari haitoshi',
  'biu.biu.building.car.single': 'Gari',
  'biu.biu.building.congra': 'Hongera!',
  'biu.biu.building.daily.list': 'Orodha ya Kila Siku',
  'biu.biu.building.detail.coin': '{$month}-{$day} {$hour}:{$min}, ulijaza {$coin} sarafu.',
  'biu.biu.building.detail.floors.one': '{$month}-{$day} {$hour}:{$min}, ulipigana {$count} {$level} {$cars} na kuharibu {$floornumer} {$floor}.',
  'biu.biu.building.floor.double': 'Ghorofa',
  'biu.biu.building.floor.single': 'Ghorofa',
  'biu.biu.building.get.reward': 'Zawadi yako!',
  'biu.biu.building.no.lucky': 'bahati mbaya',
  'biu.biu.building.no.records': 'Hakuna rekodi',
  'biu.biu.building.no.start': 'Hatua hii iko karibu kuanza',
  'biu.biu.building.one.car': 'Gari la Kiwango1',
  'biu.biu.building.ranking.list': 'Orodha',
  'biu.biu.building.recharge': 'Jaza {$value}sarafu/{$count} mara',
  'biu.biu.building.ruls.reward': 'Sheria & Zawadi',
  'biu.biu.building.rush.button': 'Nenda*{$times}',
  'biu.biu.building.to.collect': 'Sawa',
  'biu.biu.building.to.get': 'kupata',
  'biu.biu.building.to.war': 'Nenda',
  'biu.biu.building.two.car': 'Gari la Kiwango2',
  'blank': '<p>Hakuna maudhui yanayohusiana</p> <p>Tafadhali angalia njia nyingine</p>',
  'boring': 'inakera',
  'break.through.text.14': 'Hongera! Umepata tuzo',
  'call': 'Simu & Upimaji',
  'cancel': 'Ghairi',
  'chatConversation': '💬 Mizunguko ya Mazungumzo',
  'chatSpeed': 'Kasi ya kujibu',
  'chatSpeed1': 'Kasi yangu ya kujibu ujumbe',
  'chat_skill_title': 'Lazima isomwe kwa Wavuti',
  'chatting': 'Utendaji wa ujumbe wa mazungumzo',
  'chatting1': 'Utendaji wangu wa mazungumzo',
  'cms_report_text10': 'Matokeo ya adhabu:',
  'cms_report_text11': 'Historia ya adhabu',
  'cms_report_text12': 'Onyo la maneno',
  'cms_report_text13': 'Njia ya kufungia:',
  'cms_report_text14': 'Sababu za kufungia:',
  'cms_report_text15': 'Muda wa kufungia:',
  'cms_report_text16': 'Hisia za kisiasa',
  'cms_report_text17': 'Kichafu',
  'cms_report_text18': 'Shambulio na matusi',
  'cms_report_text19': 'Ukatili wa damu',
  'cms_report_text20': 'Matangazo',
  'cms_report_text21': 'Udanganyifu unaoshukiwa',
  'cms_report_text22': 'Taarifa haramu',
  'cms_report_text23': 'Mdogo',
  'cms_report_text24': 'Mwingine',
  'cms_report_text25': 'Thibitisho',
  'cms_report_text26': 'Operesheni nyeti ya akaunti, tafadhali thibitisha taarifa baada ya taarifa',
  'cms_report_text3': 'Sababu ya ripoti:',
  'cms_report_text4': 'Maelezo ya ripoti:',
  'cms_report_text5': 'Picha ya skrini ya ripoti:',
  'cms_report_text6': '*Tafadhali thibitisha taarifa zilizopo hapo juu, ili tuweze kuweka adhabu kwa taarifa.',
  'cms_report_text7': 'Kitambulisho cha ripota:',
  'cms_report_text8': 'Kitambulisho cha ripota:',
  'cms_report_text9': 'Njia ya adhabu:',
  'coin.merchant.amount': 'Kiasi:',
  'coin.merchant.change.password': 'Badilisha nenosiri',
  'coin.merchant.chat': 'Mazungumzo',
  'coin.merchant.coins.num': 'Hesabu ya Sarafu:',
  'coin.merchant.confirm.again': 'Thibitisha nenosiri la muamala tena',
  'coin.merchant.confirm.new.again': 'Thibitisha nenosiri jipya tena',
  'coin.merchant.der.amount': 'Kiasi cha Recharge:',
  'coin.merchant.der.another': 'Recharge Akaunti Nyingine',
  'coin.merchant.der.bind.phone': 'Funga nambari ya simu',
  'coin.merchant.der.bind.phone.placeholder': 'Nambari ya Simu',
  'coin.merchant.der.change.country': 'Chagua nchi',
  'coin.merchant.der.channel': 'Njia ya Malipo:',
  'coin.merchant.der.channel.tips': 'Ikiwa huwezi kukamilisha malipo kupitia njia zifuatazo, tafadhali wasiliana na WhatsApp ya timu rasmi kuuliza kuhusu ununuzi:',
  'coin.merchant.der.channel.tips.link': 'nakala',
  'coin.merchant.der.code.tips': 'Ikiwa huwezi kupokea nambari ya uthibitisho, tafadhali wasiliana na WhatsApp ya timu rasmi:',
  'coin.merchant.der.complete': 'Recharge Imekamilika',
  'coin.merchant.der.complete.tips': '{nambari} sarafu zimewekwa tena kwa {jina}! Tafadhali ingia ili kufurahia burudani zaidi!',
  'coin.merchant.der.current.country': 'Hivi sasa ukitumia njia ya malipo ya',
  'coin.merchant.der.error': '*Hakuna Matokeo Yaliyopatikana',
  'coin.merchant.der.fail': 'Kushindwa Recharge',
  'coin.merchant.der.fail.tips': 'Imeshindwa kuimarisha akaunti yako, tafadhali wasiliana nasi kwa: TT_support@molelive.com ikiwa una maswali yoyote!',
  'coin.merchant.der.id': 'TalkTalk ID',
  'coin.merchant.der.modal.title': 'Njia ya Malipo',
  'coin.merchant.der.more': 'Recharge Zaidi',
  'coin.merchant.der.name': 'Jina lako la TalkTalk:',
  'coin.merchant.der.problem': 'Kukutana na Matatizo?',
  'coin.merchant.der.redeem': 'Badilisha',
  'coin.merchant.der.resend': 'Tuma tena',
  'coin.merchant.der.sms.code': 'Ingiza nambari ya uthibitisho',
  'coin.merchant.der.sms.tips': 'Shughuli isiyo ya kawaida imegundulika. Ili kuhakikisha usalama wa akaunti yako, tafadhali kamilisha mchakato wa uthibitisho hapa chini.',
  'coin.merchant.enter': 'Ingiza',
  'coin.merchant.enter.amount': 'Ingiza kiasi',
  'coin.merchant.enter.new.password': 'Ingiza nenosiri jipya',
  'coin.merchant.enter.original.password': 'Ingiza nenosiri la awali',
  'coin.merchant.enter.password': 'Ingiza nenosiri lako la muamala',
  'coin.merchant.enter.transaction.password': 'Ingiza nenosiri la muamala',
  'coin.merchant.enter.user.id': 'Ingiza kitambulisho cha mtumiaji',
  'coin.merchant.history': 'Historia',
  'coin.merchant.history.title': 'Muamala Historia',
  'coin.merchant.id': 'ID',
  'coin.merchant.list.desc': 'Kuhamasisha sarafu kwa mtumiaji huyu ni sawa na recharge, ambayo pia itaongeza uzoefu wa vip.',
  'coin.merchant.list.title': 'Chagua kiasi',
  'coin.merchant.min.input': 'Kiasi kidogo 1000',
  'coin.merchant.not.found': 'Mtumiaji hakupatikana',
  'coin.merchant.password.error': 'Nenosiri si sahihi. Tafadhali jaribu tena.',
  'coin.merchant.password.tips': 'Nenosiri linapaswa kuwa na angalau herufi 8, na lazima liwe na herufi kubwa na ndogo pamoja na nambari.',
  'coin.merchant.recharge.title': 'Mauzo ya Sarafu Recharge',
  'coin.merchant.search': 'Uchunguzi',
  'coin.merchant.set.password': 'Weka nenosiri lako la biashara',
  'coin.merchant.success': 'Kuhamisha kumefanikiwa',
  'coin.merchant.tips': 'Unakaribia kuhamisha kiasi cha ziada kwa mtumiaji, tafadhali thibitisha jina na kiasi cha sarafu tena. Operesheni hii haiwezi kubadilishwa, na rasmi haina wajibu wa makosa yoyote.',
  'coin.merchant.title': 'Mauzo ya Sarafu',
  'coin.merchant.to': 'Kwa:',
  'coin.merchant.transfer': 'Hamisha',
  'coin.merchant.transfer.coins': 'Hamisha Sarafu',
  'coin.merchant.user': 'Mtumiaji',
  'coinBack': 'Sarafu Zilizorejeshwa',
  'coins.battle.draw.drawing.tips': 'Vidokezo vya Kuchora',
  'coins.battle.draw.drawing.tips.desc': 'Nyakati za Kuchora Hazitoshi! Recharge ili kupata nyakati zaidi sasa!',
  'coins.battle.draw.drawing.tips.recharge.now': 'Recharge Sasa',
  'coins.battle.draw.no.recharge': 'Unahitaji kuchaji {coinToDrawCount} sarafu kwa mara ya kwanza.',
  'coins.battle.draw.recharged': 'Recharge iliyokusanywa ya {coinToDrawCount} sarafu: Nyakati za Kuchora +1',
  'coins.battle.draw.remain.times': 'Nyakati zilizobaki: {remainTime} nyakati',
  'coins.battle.draw.total.coins': 'Imepatikana:<span class=\'num\'>{totalRechargeCoins}</span> Sarafu',
  'coins.battle.entry.btn': 'Recharge {coinToDrawCount} sarafu ili kupata',
  'coins.battle.entry.desc': 'Una nafasi moja ya kuchora sarafu hadi milioni 1!',
  'coins.battle.entry.title': 'Faida za Kushangaza',
  'coins.battle.record.complete.task': 'Kamilisha Kazi {N}',
  'coins.battle.record.head.coins.or.tasks': 'Sarafu/Kazi',
  'coins.battle.record.head.time': 'Wakati',
  'coins.battle.record.tab.draw.record': 'Rekodi ya Kuchora',
  'coins.battle.record.tab.number.of.draws': 'Idadi ya michoro',
  'coins.battle.result.get': 'Pata',
  'coins.battle.result.prize.pool': 'Pata {N}% sarafu za hazina ya zawadi',
  'coins.battle.result.title': 'Hongera!',
  'coins.battle.rules.not.show.again': 'Usionyeshe tena.',
  'coins.battle.task.completed': 'Imekamilika',
  'coins.battle.task.go': 'Nenda',
  'coins.battle.task.tips': 'Kila kazi unayokamilisha inashinda kuchora.',
  'coins.battle.task.title': 'Eneo la kuonyesha kazi',
  'coins.battle.time': 'wakati',
  'coins.battle.times': 'nyakati',
  'common.Cap.Dating': 'Kukutana',
  'common.Cap.Top1': 'Top1',
  'common.Cap.Uncompleted': 'Haijakamilika',
  'common.Collect': 'Kusanya',
  'common.EXP': 'EXP',
  'common.cap.Close': 'Funga',
  'common.cap.Coins': 'Sarafu',
  'common.cap.Collect': 'Kusanya',
  'common.cap.Collected': 'Zimekusanywa',
  'common.cap.Confirm': 'Thibitisha',
  'common.cap.Congratulations': 'Hongera',
  'common.cap.Continue': 'Endelea',
  'common.cap.Countdown': 'Kudumu',
  'common.cap.Countdown.to.Start': 'Kudumu Kuanzia',
  'common.cap.Customer.Server': 'Huduma kwa Wateja',
  'common.cap.Day': 'Siku',
  'common.cap.Event.To.Start': 'Tukio linaelekea kuanza',
  'common.cap.Follow': 'Fuata',
  'common.cap.Go': 'Nenda',
  'common.cap.Hour': 'Saa',
  'common.cap.Limited.Gifts': 'Zawadi Zilizopangwa',
  'common.cap.Min': 'Dakika',
  'common.cap.No': 'Hapana',
  'common.cap.Ranking': 'Ufunguo',
  'common.cap.Ranking.click': 'Bonyeza',
  'common.cap.Ranking.click.text': 'kuangalia zawadi tofauti',
  'common.cap.Recharge': 'Rekaji',
  'common.cap.Record': 'Rekodi',
  'common.cap.Rewards': 'Zawadi',
  'common.cap.Rights': 'Haki Zote Zimehifadhiwa na SOYO',
  'common.cap.Rules': 'Kanuni',
  'common.cap.Sec': 'Sekunde',
  'common.cap.Start': 'Anza',
  'common.cap.Success': 'Mafanikio',
  'common.cap.Successfully.Collected': 'Imekusanywa kwa Mafanikio',
  'common.cap.Sure': 'Hakika',
  'common.cap.Unfortunately.Yes': 'Kwa bahati mbaya Ndio',
  'common.cap.Waiting': 'Kusubiri',
  'common.cap.cancel': 'Ghairi',
  'common.cap.confirm': 'Thibitisha',
  'common.cap.event.over': 'Tukio limeisha',
  'common.cap.month1': 'Jan',
  'common.cap.month10': 'Oct',
  'common.cap.month11': 'Nov',
  'common.cap.month12': 'Dec',
  'common.cap.month2': 'Feb',
  'common.cap.month3': 'Mar',
  'common.cap.month4': 'Apr',
  'common.cap.month5': 'May',
  'common.cap.month6': 'Jun',
  'common.cap.month7': 'Jul',
  'common.cap.month8': 'Aug',
  'common.cap.month9': 'Sept',
  'common.cap.my.times': 'nyakati zangu',
  'common.cap.next.round': 'Mzunguko ujao utafuata hivi karibuni…',
  'common.cap.not.remind': 'hakuna ukumbusho zaidi',
  'common.cap.time': 'wakati',
  'common.cap.times': 'nyakati',
  'common.cap.update': 'Tafadhali sasisha toleo ili kutumia vipengele vipya',
  'common.number': 'Nambari',
  'common.recharge.text': 'Sarafu hazitoshi. Je, unataka kuchaji?',
  'common.up.DAYS': 'SIKU',
  'common.up.HOURS': 'SAA',
  'common.up.MINS': 'DAKIKA',
  'common.up.OK': 'Sawa',
  'common.up.RECEIVED': 'MCHARMER',
  'common.up.RULES': 'KANUNI',
  'common.up.SECS': 'SEKUNDE',
  'commonErr': '<p>System inashughulika,</p><p>tafadhali jaribu tena baadaye</p>',
  'confirm': 'Thibitisha',
  'count': '🙋‍♀️ Ujumbe',
  'coupon_pay_txt2': 'Tu kwa {%s} pekee',
  'coupon_pay_txt3': '{%s}% Coupon za Sarafu',
  'coupon_pay_txt4': 'sarafu',
  'cp.list.cur.reward.text': 'Fungua eneo hili kupata zawadi zifuatazo.',
  'cp.list.limit.tips': 'Tuma zawadi za kikomo kufikia kiwango kinachoweza kufungua eneo la kukutana.',
  'cp.list.unlock.contributor': 'Mchango wa Eneo',
  'crazy.bulider.build.all': 'Jenga Yote',
  'crazy.bulider.build.n': 'Jenga {N} Wakati',
  'crazy.bulider.celebrate.desc': 'Hongera kwa kujenga {N} ghorofa!',
  'crazy.bulider.click.celebrate': 'Bonyeza Kusherehekea',
  'crazy.bulider.congura': 'Hongera!',
  'crazy.bulider.daily': 'Ranki ya Kila Siku',
  'crazy.bulider.daily.top1': 'TOP1 ya Kila Siku',
  'crazy.bulider.floors.n': 'Ghorofa {N}',
  'crazy.bulider.get.more': 'PATA ZAIDI',
  'crazy.bulider.luck.gift.desc': 'Tuma zawadi ya bahati kila {N} sarafu = 1{hammerIcon}',
  'crazy.bulider.lucky.desc': 'Chagua Sanduku 1 la Bahati kupata bonasi!',
  'crazy.bulider.lucky.moment': '⭐️Wakati wa Bahati⭐️',
  'crazy.bulider.model.rewards.desc': 'Umepewa tuzo',
  'crazy.bulider.ok': 'Sawa',
  'crazy.bulider.opps': 'Ooh!',
  'crazy.bulider.progress.current': 'Hali ya Sasa: {M}={N}',
  'crazy.bulider.progress.target': 'Lengo:',
  'crazy.bulider.ranking': 'Ranki',
  'crazy.bulider.rewards.tab1': 'Zawadi za Ghorofa',
  'crazy.bulider.rewards.tab2': 'Zawadi za Ranki',
  'crazy.bulider.share': 'Shiriki',
  'crazy.bulider.share.desc1': 'Umevuka 90% ya wajenzi! Shiriki haraka mtazamo wa sasa na marafiki zako!',
  'crazy.bulider.share.desc2': '*Kushiriki kwa mara ya kwanza kwa mafanikio katika Moment kunaweza kupata zawadi za kipekee kwa wajenzi bora ↓.',
  'crazy.bulider.share.desc3': '{X} watu pia walianza kujenga majengo kwa kuona moment yako!',
  'crazy.bulider.share.desc4': 'Asante kwa ushawishi wako!',
  'crazy.bulider.share.desc5': 'Majengo marefu yako chini ya udhibiti wangu!',
  'crazy.bulider.share.moment': 'Shiriki Kwa Moment',
  'crazy.bulider.share.ok': 'Sawa',
  'crazy.bulider.share.reward': 'Umepewa tuzo',
  'crazy.bulider.share.success': 'Mafanikio ya Kushiriki!',
  'crazy.bulider.share.text': '#👷Mjenzi Wazimu🚧#\nMamlaka ya Juu Yanatoa Athari kwa Ulimwengu! 🌏\n{N} Sakafu zimejengwa kwa shauku🔥\nKiwango cha Kimataifa: #{Rank} 👑\nFursa nzuri ya kujenga jengo refu mwenyewe!',
  'crazy.bulider.status.count': 'Hesabu',
  'crazy.bulider.status.end': 'Tukio limeisha',
  'crazy.bulider.status.start': 'Tukio linaanza hivi karibuni',
  'crazy.bulider.time.not.desc': 'Wakati wa ujenzi haujatosha!<br/>Zawadi kuu inakusubiri!',
  'crazy.bulider.total': 'Urangranki Jumla',
  'crazy.bulider.waiting': 'Inasubiri',
  'crazybuilder.friends.list': 'Orodha ya Marafiki',
  'crazybuilder.friends.list.text': 'Ziyara za kila siku zitaongeza ❤️ kwa mji wa rafiki yako.',
  'crazybuilder.friends.list.visit': 'Tembelea',
  'crazybuilder.king.record': 'Rekodi ya juu kabisa',
  'crazybuilder.map.enter': 'Mji',
  'crazybuilder.map.notify.btn': 'Sawa',
  'crazybuilder.map.notify.desc': 'Mji wako unapata upendeleo! Endelea kujenga ili kuvutia wageni zaidi!',
  'crazybuilder.map.notify.title': 'Hongera!',
  'crazybuilder.map.share.btn': 'Shiriki Sasa',
  'crazybuilder.map.share.desc': 'Shiriki Mji wako wa Ufanisi! Waalike marafiki zako kusherehekea pamoja!',
  'crazybuilder.map.share.text': '#👷Mjenzi Wajabu🚧#\nUwezo wa juu unahitajika kujenga Miji ya Ufanisi! 👑💪\n{N} Nyumba zimeandikwa jina langu-{Jina la Utani}.🌃\n{M} mapendeleo❤️ yamepewa Mji wangu wa Ufanisi⭐️\nKaribu mjini kwangu kuona pengo letu😎',
  'crazybuilder.mine.record': 'Rekodi Yangu ya Sasa',
  'crazybuilder.reaching.floors': 'Haiwezi kushirikiwa hadi kufikia ghorofa zilizokusudiwa',
  'crazybuilder.toast.reach': 'Fikia ghorofa {n} unaweza kushiriki Mafanikio yako ya Jengo! Na unaweza kupata zawadi zifuatazo:',
  'cumulativeMiss': 'Kukosa-Jumla',
  'currentCycle': 'Mzunguko wa Sasa',
  'cycleDiamonds': 'Almasi mzunguko huu',
  'daily': 'Kila Siku',
  'delete_account_web': 'Futa Akaunti',
  'delete_account_web1': '1. Fungua Programu na ingia kwenye ukurasa mkuu, bonyeza chini kulia kuingia kwenye Tab ya Mimi.',
  'delete_account_web2': '2. Bonyeza mipangilio baada ya kuingia kwenye Tab ya Mimi.',
  'delete_account_web3': '3. Bonyeza futa akaunti baada ya kuingia kwenye mipangilio.',
  'delete_account_web4': '4. Thibitisha hatua ya kwanza ili kufuta akaunti milele.',
  'delete_account_web5': '5. Thibitisha hatua ya pili ili kutoweza kuingia kwa kutumia akaunti hiyo hiyo.',
  'delete_account_web6': '6. Thibitisha hatua ya mwisho ili kufuta taarifa zote zinazohusiana na binafsi.',
  'delete_account_web7': '7. Baada ya kumaliza hatua zote hapo juu. Akaunti yako imefutwa kwa mafanikio, pamoja na taarifa zako zote za kibinafsi na data ya akaunti. Jukwaa letu halitahifadhi tena data yako katika hifadhidata yetu.',
  'delete_account_web_title': 'Mpendwa Mtumiaji wa Soyou. Asante kwa kutumia na kusaidia bidhaa yetu. Ikiwa ungependa kufuta akaunti yako, tafadhali angalia hatua zifuatazo ili kuendelea:',
  'details': 'Maelezo ya Almasi',
  'diamond.tab.chat': 'chat',
  'diamond.tab.voice': 'Sauti chama',
  'distributionOfDiamondIncome': 'Usambazaji wa mapato ya almasi',
  'dream.city.charm': 'Chara',
  'dream.city.charm.rank': 'Chara',
  'dream.city.city.map': 'Ramani ya Jiji',
  'dream.city.current.coins': 'Sarafu za sasa',
  'dream.city.current.diamonds': 'Almasi za sasa',
  'dream.city.go': 'Nenda',
  'dream.city.received': 'Hongera! Umepokea',
  'dream.city.rule.reward': 'Sheria na Zawadi',
  'dream.city.rules': 'Sheria za Tukio',
  'dream.city.supply.reward': 'Mikopo ya Kituo cha Ugavi',
  'dream.city.top5': 'Watumiaji 5 bora ambao watafika kwenye kituo cha ugavi kwa haraka wataweza kupata mikopo ya ugavi.',
  'dream.city.waiting': 'kusubiri',
  'dream.city.wealth': 'Ufalme',
  'dream.city.wealth.rank': 'Ufalme',
  'dream.city.will.get': 'Utapata',
  'efficient_text_10': 'Kama ulifika kiwango',
  'efficient_text_11': 'Eleza',
  'efficient_text_12': 'Fikia kiwango',
  'efficient_text_13': 'Hauja fika kiwango',
  'efficient_text_14': 'Ikiwa muda kwenye kipaza sauti utaendelea hadi siku inayofuata, unahesabiwa kama muda wa siku iliyopita',
  'efficient_text_15': 'Muda nje ya kipaza sauti - Muda kwenye kipaza sauti <%$min',
  'efficient_text_16': 'Muda nje ya kipaza sauti - Muda kwenye kipaza sauti> = %$min',
  'efficient_text_17': '12/1 9:00:00 Muda kwenye kipaza sauti haukufikia kiwango, hauwezi kuhesabiwa kama muda wenye ufanisi',
  'efficient_text_18': '12/1 23:00:00 Muda kwenye kipaza sauti uliendelea hadi 12/2 na kudumu kwa dakika 90 mfululizo, hivyo unahesabiwa kama muda wakati wa 12/1',
  'efficient_text_19': '2. Siku zenye ufanisi za chumba',
  'efficient_text_2': 'Muda wenye ufanisi',
  'efficient_text_20': 'Katika chumba cha sauti, muda wote wenye ufanisi unajumuishwa wakati wa siku> = %$ min ni siku yenye ufanisi. Kadri idadi ya siku zenye ufanisi inavyokuwa kubwa, ndivyo shughuli inavyokuwa kubwa, na kiwango cha shughuli kinaathiri moja kwa moja mikopo unayopata.',
  'efficient_text_21': 'Jumla ya muda wenye ufanisi',
  'efficient_text_22': '12/1 Mara 3 kwenye kipaza sauti wakati wa siku: 15min +35min +90min. Kwa sababu dakika 15 hazikukidhi kiwango, muda wenye ufanisi = 90 +35 = 125min = 02H 05min',
  'efficient_text_23': '12/1 Muda wa ufanisi wa siku kwa jumla = 02H 05min> = %$min, ambayo inahesabiwa kama siku yenye ufanisi',
  'efficient_text_24': '3. Muda kwenye kipaza sauti',
  'efficient_text_25': 'Muda kwenye kipaza sauti lazima uwe muda wenye ufanisi, na muda wenye ufanisi lazima uwe> = %$min. Muda kwenye kipaza sauti unamaanisha tu muda wa kuzungumza kwenye kipaza sauti katika chumba. Utachukuliwa kama muda wenye ufanisi wakati muda kwenye kipaza sauti> = %$min, kama vile:',
  'efficient_text_26': '4. Maelezo ya data',
  'efficient_text_27': 'Data itakuwekwa kulingana na mzunguko uliochaguliwa',
  'efficient_text_28': 'Almasi',
  'efficient_text_29': 'Mazungumzo',
  'efficient_text_30': 'Chumba cha Sauti',
  'efficient_text_31': 'Maelezo',
  'efficient_text_32': 'Tarehe',
  'efficient_text_33': 'Muda kwenye kipaza sauti',
  'efficient_text_34': 'Muda wenye ufanisi wa Chumba cha Sauti',
  'efficient_text_35': 'Siku zenye ufanisi za Chumba cha Sauti',
  'efficient_text_5': 'Siku yenye ufanisi',
  'efficient_text_6': '1. Muda halali katika chumba',
  'efficient_text_7': 'Katika chumba cha sauti, muda kwenye kipaza sauti - muda nje ya kipaza sauti> = %$ min ni muda wenye ufanisi kwenye kipaza sauti. Tunawahimiza wale walio kwenye kipaza sauti kuchukua hatua kuzungumza na kuwasiliana na marafiki wazuri kwa muda mrefu, kama vile:',
  'efficient_text_8': 'Muda kwenye kipaza sauti',
  'efficient_text_9': 'Muda nje ya kipaza sauti',
  'exchange_text_1': 'Badilisha',
  'exchange_text_10': 'Pata:',
  'exchange_text_13': 'Hifadhi ya Almas haitoshi',
  'exchange_text_14': 'Badilisha imefanikiwa',
  'exchange_text_16': 'Badilisha imefeli.',
  'exchange_text_18': 'Imepita mpaka wa kubadilisha.',
  'exchange_text_2': 'Hifadhi ya Sarafu',
  'exchange_text_3': 'Hifadhi ya Almas',
  'exchange_text_4': 'Badilisho la Kawaida',
  'exchange_text_5': 'Sheria za Kubadilisha',
  'exchange_text_6': 'Kiwango cha Kubadilisha',
  'exchange_text_7': 'Mpaka wa Kila Siku wa Kubadilisha',
  'exchange_text_8': 'Thibitisha kubadilisha?',
  'exchange_text_9': 'Iliyotumika:',
  'family.battle.new.up.need.s': 'Up Need {N}',
  'family.bronze.family': 'Familia ya Shaba',
  'family.diamond.family': 'Familia ya Almasi',
  'family.diamonds.exch': 'Kubadilishana Almasi',
  'family.division.privilege': 'Kigawanyiko na Faida ya Kigawanyiko',
  'family.division.privilege.describe': 'Kigawanyiko kinategemea matumizi ya kila mwezi, kinarejea tarehe 1 ya kila mwezi. Kigawanyiko kinaweza kuboreshwa, kuhifadhiwa na kushuka. Kuhifadhi kiwango cha sasa kunahitaji tu kufikia 100% ya matumizi yanayohusiana na kuboresha.',
  'family.exp.content.title.1': 'Jinsi ya kupata Familia EXP?',
  'family.exp.content.title.2': 'Kiwango cha Familia na Faida ya Kiwango',
  'family.exp.content1.text.1': '{%s1} Sarafu',
  'family.exp.content1.text.2': '1 EXP',
  'family.exp.content1.text.3': '50 Almasi',
  'family.exp.content1.text.title.1': 'Wajumbe wa familia wanatuma zawadi',
  'family.exp.content1.text.title.2': 'Wajumbe wa familia wanapokea zawadi',
  'family.exp.content1.text.title.3': 'Kamilisha kazi za familia',
  'family.exp.table.title.1': 'EXP',
  'family.exp.table.title.2': 'Mwanachama',
  'family.exp.table.title.3': 'Naibu Kapteni',
  'family.exp.table.title.4': 'Meneja',
  'family.exp.title': 'Uzoefu wa Familia',
  'family.football.no.tips': 'Hakuna vidokezo zaidi kwa wakati ujao',
  'family.football.target': 'Malengo ya Zawadi za Sarafu',
  'family.golden.family': 'Familia ya Dhahabu',
  'family.king.family': 'Familia ya Mfalme',
  'family.label.chatroom': 'Background ya Chumba cha Mazungumzo',
  'family.label.familyBg': 'Background ya Familia',
  'family.label.frame': 'Frame ya Familia',
  'family.label.tag': 'Tag ya Familia',
  'family.level.instructions': 'MAELEKEZO YA KIWANGO CHA FAMILIA',
  'family.new.diamonds.exch': 'Alama',
  'family.silver.family': 'Familia ya Fedha',
  'family.task.captain.task': 'Kazi ya Kapteni',
  'family.task.cumulative': 'Kazi ya Jumla',
  'family.task.daily.exp': 'EXP YA KILA SIKU',
  'family.task.exp.describe': 'EXP unayoichangia familia',
  'family.task.family.level': 'Kiwango cha Familia kinategemea EXP iliyokusanywa. Kila kiwango kinahusiana na faida ifuatayo.',
  'family.task.interactive': 'Kazi ya Kihusiano',
  'family.task.invite.join': 'Mwambie Marafiki Kujiunga na Familia',
  'family.task.monthly.exp': 'EXP YA KILA MWEZI',
  'family.task.others': 'Wengine',
  'family.task.rules.first': 'Baada ya kukidhi masharti ya sanduku la hazina la familia, zawadi katika sanduku la hazina zitafunguliwa kwa bahati nasibu.',
  'family.task.rules.four': 'Zawadi zitatolewa moja kwa moja baada ya sanduku la hazina kufunguliwa.',
  'family.task.rules.second': 'Wajumbe wanaokamilisha kazi kabla ya sanduku la hazina kufunguliwa watapokea zawadi.',
  'family.task.rules.three': 'Vitu vitagawanywa kwenye Bag ya Washindi, na zawadi zingine kama EXP au sarafu zitatolewa kwa akaunti.',
  'family.task.tips': 'Kamilisha kazi ndani ya siku 2 za kwanza za kujiunga na Familia ili kupata uzoefu mara mbili.',
  'family.task.treasure.chest': 'Sanduku la Hazina la Familia',
  'family.task.treasure.unlocked': 'Ikiwa idadi ya wajumbe itafikia %s, sanduku la hazina la familia litafunguliwa saa 0 a.m. kila siku.',
  'family.task.your.rewards': 'Zawadi zako',
  'fes.of.sa.catch.btn': 'CATCH ({N})',
  'fes.of.sa.catch.cong.text': 'Falid kushika mwanakondoo wakati huu, tunakutumia salamu bora na zawadi nyingine!',
  'fes.of.sa.catch.cong.title': 'Hongera!',
  'fes.of.sa.catch.oops': 'Ndio..',
  'fes.of.sa.catch.oops.text': 'Falid kupata zawadi wakati huu, TalkTalk inakutumia salamu bora! Jaribu tena!',
  'fes.of.sa.catch.suc.text': 'Hongera! Umepata mwanakondoo 1 bure!Mwanakondoo bure kutoka lambfold itakadiria alama 5 mara kwenye Lamb Ranking!',
  'fes.of.sa.catch.suc.title': 'Umefanikiwa Kushika!',
  'fes.of.sa.collect.tools': 'Kusanya zana za Kupika Mwanakondoo',
  'fes.of.sa.combine': 'unganisha',
  'fes.of.sa.count': 'X{N}',
  'fes.of.sa.draw': 'draw*{%d}',
  'fes.of.sa.draw.again': 'Draw tena',
  'fes.of.sa.event.gift': 'Zawadi ya Tukio',
  'fes.of.sa.free': 'BURE!',
  'fes.of.sa.lamb.rewards': 'ZAWADI BURE KUTOKA LAMBFOLD',
  'fes.of.sa.lamb.top': 'Shika mwanakondoo bure, pata alama 5 mara!',
  'fes.of.sa.not.start': 'Tukio linaelekea kuanza',
  'fes.of.sa.ok': 'Sawa',
  'fes.of.sa.rank.daily': 'Kila siku',
  'fes.of.sa.rank.tab1': 'Mwanakondoo wa Kupika Ranking',
  'fes.of.sa.rank.tab2': 'Charm Ranking',
  'fes.of.sa.rank.total': 'Jumla',
  'fes.of.sa.ranking': 'Ranking',
  'fes.of.sa.recharge.btn': 'Rekaji',
  'fes.of.sa.records': 'Record',
  'fes.of.sa.send.btn': 'Tuma',
  'fes.of.sa.tab1': 'Changamoto ya Kupika Mwanakondoo',
  'fes.of.sa.tab2': 'Lambfold Wazimu',
  'fes.of.sa.ticket.enough': 'Tiketi hazitoshi, tuma zawadi kupata zaidi',
  'fes.of.sa.time': 'Wakati',
  'fes.of.sa.tip.text': 'Una zaidi ya {N} mwanakondoo wa kuunganisha, unataka kuunganisha sasa?',
  'fes.of.sa.unlock.btn': 'TUMA ZAWADI KUFUNGUA',
  'fes.of.sa.wait.lock': 'KUFUNGULIWA!',
  'fishing.activity.achievement': 'MAFANIKIO',
  'fishing.activity.bomber': 'Bomber',
  'fishing.activity.cap.Date': 'Tarehe',
  'fishing.activity.cap.Records': 'Records',
  'fishing.activity.cap.Unfinished': 'Haijakamilika',
  'fishing.activity.cap.no.record.yet': 'Hakuna rekodi bado.',
  'fishing.activity.catche.single': 'Kuna kukamata mpya!',
  'fishing.activity.catches.more': 'Kuna kukamata mpya!',
  'fishing.activity.congrats': 'Hongera!',
  'fishing.activity.energy': 'ENERGY',
  'fishing.activity.energy.not': 'Thamani ya nishati haitoshi!',
  'fishing.activity.energy.tips': 'Kazi za kila siku zinapaswa kusasishwa saa 00:00, kumbuka kukusanya zawadi kwa wakati!',
  'fishing.activity.fish.ticket.not': 'Kuponi haitoshi!',
  'fishing.activity.fishing.big': 'Bahati! Kukutana na Samaki Kubwa! Bonyeza mtego kuongeza nguvu ya kuvuta na kufikia thamani ya lengo ili kukamata samaki mkubwa!',
  'fishing.activity.fishnet': 'Nyavu za Samaki',
  'fishing.activity.gallery': 'AKWARIUMU',
  'fishing.activity.gallery.tips': 'Kusanya aina zote za samaki kupokea sarafu za ukarimu!',
  'fishing.activity.get.more': 'PATA ZAIDI',
  'fishing.activity.go': 'Nenda',
  'fishing.activity.new': 'MPYA',
  'fishing.activity.not.time': 'Hatua hii inaelekea kuanza',
  'fishing.activity.ok': 'Sawa',
  'fishing.activity.put.aquarium': 'Weka kwenye Akvaryum',
  'fishing.activity.rank': 'BINGWA',
  'fishing.activity.rank.tips': 'Nyota 5 Bora za Uvuvi wa Kila Siku hupata zawadi za ziada!',
  'fishing.activity.records.coupon': 'Kuponi',
  'fishing.activity.records.fish': 'Samaki',
  'fishing.activity.records.others': 'Nyingine',
  'fishing.activity.slipped.away': 'Samaki walitoroka!',
  'fishing.activity.start.fishing': 'Anza uvuvi',
  'fishing.activity.step1': 'Karibu! Bonyeza kwenye mtego wa uvuvi kuvua bure!',
  'fishing.activity.step10': 'Kukamata aina za samaki zinazofanana kutabadilishwa moja kwa moja kuwa Kuponi, ambazo zinaweza kutumika kununua vitu kwenye Duka!',
  'fishing.activity.step12': 'Rudi kesho unaweza kupata Bomber 1 bure zaidi!',
  'fishing.activity.step3': 'Kupata aina mpya ya samaki inaweza kuangaziwa katika akvaryumu, na kukusanya samaki wote kunaweza kupata zawadi za sarafu nyingi!',
  'fishing.activity.step5': 'Samaki tena!',
  'fishing.activity.step8': 'Hongera kupata Bomber bure! Jaribu nguvu ya Bomber sasa!',
  'fishing.activity.store': 'DUKA',
  'fishing.activity.store.buy': 'Nunua',
  'fishing.activity.store.limit': 'Kikomo:',
  'fishing.activity.store.sold.out': 'IMESHAKAMILIKA',
  'fishing.activity.try.again': 'JARIBU TENA',
  'fishing.activity.you.got': 'Umepewa:',
  'fission.cancel': 'Ghairi',
  'fission.coins': 'sarafu',
  'fission.relation.by.amount': 'Kiasi',
  'fission.relation.by.time': 'Kwa Wakati',
  'fission.trouble': 'Je, unapata shida na recharge?',
  'flowWater': 'Maelezo ya Sarafu',
  'gacha.play.1': 'Fungua',
  'gacha.play.2': 'mara',
  'gacha.play.3': 'wakati',
  'game.king.attack': 'Wakati wa Tuzo',
  'game.king.award.time': 'Wakati wa Zawadi',
  'game.king.become.nick': 'Hongera kwa {nickname} kuwa {Awardname}',
  'game.king.become.self': 'Hongera kwa kuwa {Awardname}',
  'game.king.bounds.gold': 'Dhahabu ya Bonus',
  'game.king.brave.dragon.island': 'Kisiwa cha Shujaa Dragon',
  'game.king.cog': 'Hongera!',
  'game.king.cur.strogest': 'Nguvu ya sasa',
  'game.king.current.battle': 'Thamani ya sasa ya vita',
  'game.king.divide.pool': 'Gawanya mzunguko wa sarafu*{receiveCoin}',
  'game.king.end.desc': 'Mpendwa shujaa jasiriHongera kwa kufikia #{rankings} yako katika Warrior Rankings, na kupokea zawadi zifuatazo',
  'game.king.game.king': 'Mfalme wa Mchezo',
  'game.king.get.rewards': 'Pata Zawadi',
  'game.king.go.center': 'Mpendwa, nguvu yako ya kupigana haitoshi. Tafadhali shiriki katika mchezo ili kupata nguvu ya kupigana',
  'game.king.king.desc': 'Pointi za duru hii',
  'game.king.king.model.coin': 'Vita kwa ajili ya Kiti cha enzi: Kupata Sarafu za Dhahabu {receiveCoin}',
  'game.king.king.model.times': 'Idadi ya nyakati umekuwa mfalme wa mchezo leo: {amount}',
  'game.king.king.reward': 'Zawadi ya Mfalme',
  'game.king.last.warrior': 'Wapiganaji wa Pigo la Mwisho',
  'game.king.lucky.warrior': 'Mpiganaji Mwenye Bahati',
  'game.king.no': 'HAPANA',
  'game.king.not.reminder': 'Hakuna maonyo zaidi',
  'game.king.other.king.rewards': 'Hongera kwa {nickname} kwa kuwa {Awardname} na kupata {receiveCoin} dhahabu!',
  'game.king.prize.pool': 'Bodi ya Zawadi',
  'game.king.reminder': 'Kumbusho',
  'game.king.reward': 'Zawadi',
  'game.king.reward.name': 'Jina la Zawadi',
  'game.king.score': 'ALAMA',
  'game.king.self.king.rewards': 'Hongera kwa kuwa {Awardname} na kupokea: {receiveCoin} sarafu za dhahabu',
  'game.king.spend.attack': 'Kama kutumia {N} nguvu ya vita kushambulia',
  'game.king.strongest.warrior': 'Shujaa Mwenye Nguvu',
  'game.king.tab1': 'Mzozo wa Kiti',
  'game.king.tab2': 'Kisiwa cha Joka Jasiri',
  'game.king.unused.battle': 'Pointi za Vita Zisizotumika',
  'game.king.warrior.dialog.text': 'Hongera kwa kuwa {Awardname} mnamo {time} na kupata: {receiveCoin} sarafu za dhahabu!',
  'game.king.warrior.ranking': 'Ufunguo wa Shujaa',
  'game.king.warrior.rewards': 'Zawadi za Shujaa',
  'game.king.will.start': 'INAKARIBIA KANUSHA',
  'game.king.yes': 'NDIO',
  'game.king.you.is.king': 'WEWE NI Mfalme wa Michezo',
  'game.list.play.now': 'Nenda kucheza michezo',
  'game.list.plus.empyt.list': 'Hakuna data',
  'game.list.rewards.coin.reward.tag': 'Kufikia thamani ya kigezo',
  'game.list.rewards.coin.reward.title': 'Zawadi za sarafu za dhahabu',
  'game.list.rewards.prop.reward.title': 'Zawadi za Prop',
  'game.task.center.get': 'Pata',
  'game.task.center.received': 'Imepokelewa',
  'gamecenter_ranking_txt6': 'Ufunguo wa Bahati',
  'gamecenter_ranking_txt7': 'Shinda zaidi ya sarafu 5000 kwenye mchezo ili kuweza kuingia kwenye orodha ya viongozi, huku watumiaji wapya wanakuwa kwenye nafasi za juu.',
  'getDiamondsDay': 'Diamonds leo:',
  'getDiamondsMonth': 'Diamonds mwezi huu:',
  'gift.list.plus.up.need': 'Inahitajika',
  'gift.wall.help.text1': 'Zawadi zinazozidi {num} sarafu kwa wakati mmoja zitaonekana kwenye ukuta wa zawadi',
  'gift.wall.help.text2': 'Zawadi yenye sarafu nyingi zaidi itaonyeshwa kwenye orodha ya kwanza',
  'gift.wall.help.text3': 'Rekodi kwenye ukuta wa zawadi itahifadhiwa kwa masaa 24',
  'gift.wall.title': 'Zawadi',
  'hot': 'Moto',
  'hungry.ghost.collect': 'Kusanya',
  'hungry.ghost.go.look': 'Angalia sasa!',
  'hungry.ghost.next.round': 'Zamu inayofuata',
  'hungry.ghost.no.time.yet': 'Bado si wakati',
  'hungry.ghost.ok': 'Sawa',
  'hungry.ghost.ranking.tab.receive': 'Ufunguo wa Charm',
  'hungry.ghost.ranking.tab.send': 'Ufunguo wa Utajiri',
  'hungry.ghost.rewards.tips': 'Kwa maelezo kuhusu kupata Sarafu na Almasi, tafadhali angalia ukurasa wa sheria.',
  'hungry.ghost.scene.rewards.desc': 'Baada ya kushiriki katika kufungua eneo la sasa, unaweza kupata zawadi zifuatazo, na MVP ina zawadi za ziada.',
  'hungry.ghost.scene.tips': 'Toa zawadi za kikomo katika seva na ufikie idadi husika ya sarafu ili kufungua maeneo na kupata zawadi. MVP wana zawadi za ziada.',
  'hungry.ghost.scene.unlock.modal.mvp.tag': 'MVP anaweza kupata',
  'hungry.ghost.scene.unlock.modal.title': 'Hongera kwa kushiriki katika kufungua eneo:',
  'hungry.ghost.scene.unlock.modal.you.can.get': 'Anaweza kupata',
  'hungry.ghost.special.gift.contribution': 'Sanduku la mchango',
  'hungry.ghost.special.gift.desc': 'Thamani ya zawadi ya kikomo iliyokusanywa iliyopokelewa {%d} sarafu inaweza kushiriki katika uchaguzi wa nyota wenye bahati ({%z}/{%m})',
  'hungry.ghost.special.gift.lucky': 'Sanduku la Bahati',
  'hungry.ghost.special.gift.title': 'Sanduku la ziada',
  'hungry.ghost.special.gift.to.be.drawn': 'Kuchorwa',
  'hungry.ghost.special.gift.to.complete': 'Kamilisha sasa',
  'hungry.ghost.tab.ranking': 'Ufunguo',
  'hungry.ghost.tab.scene': 'Adventure ya Halloween',
  'hungry.ghost.waiting': 'kusubiri',
  'iftar.congratulations.unlocking': 'Hongera kwa kushiriki katika kufungua sahani:',
  'iftar.daily.ranking': 'Ushindani wa Kila Siku',
  'iftar.reward.target': 'Malipo ya Sarafu Malengo',
  'iftar.total.ranking': 'Ushindani wa Jumla',
  'iftar.you.received': 'Umepokea:',
  'ios_rechargeguide_txt3': 'Sarafu Nyuma',
  'ios_rechargeguide_txt4': 'Dai',
  'iosso_wallet_txt1': 'Zaidi',
  'iosso_wallet_txt2': 'Piga fold',
  'iosso_wallet_txt7': 'Itarudi kwenye Wallet ndani ya {%s} sekunde.',
  'iosso_wallet_txt8': 'Rudi Nyuma',
  'jungle.e.Total': 'Jumla',
  'jungle.e.btn.finish': 'Tuma zawadi zaidi za tukio, shiriki sarafu zaidi>>',
  'jungle.e.btn.finish.anchor': 'Pokea zawadi zaidi za shughuli na shiriki almasi zaidi!',
  'jungle.e.coin.finish': 'Synthesize zaidi Sanduku la Hazina, pata sarafu zaidi kutoka Sanduku la Sarafu Kuu!',
  'jungle.e.coin.finish.anchor': 'Pokea zawadi zaidi za tukio na shiriki almasi zaidi!',
  'jungle.e.coin.reach': 'Upeo wa Zawadi za wanachama wote ufikie {N} kufungua Sanduku la Sarafu Kuu',
  'jungle.e.coin.reach.anchor': 'Fungua Sanduku la Almasi Kuu wakati jumla ya zawadi zilizopokelewa inafikia {N}',
  'jungle.e.coin.rewards': 'Maalum ya Lambfold',
  'jungle.e.collect.desc': 'Kusanya Moto kila siku kupata zawadi maalum & pata {N} mara ya alama za Charm Ranking!',
  'jungle.e.collect.title': 'Kusanya Moto',
  'jungle.e.combine': 'Unganisha',
  'jungle.e.cong.title': 'Hongera!',
  'jungle.e.daily': 'Kila siku',
  'jungle.e.day.refresh': 'Kila siku inasasishwa saa',
  'jungle.e.divied.coin': 'Kwa sasa unaweza kushiriki: {N} sarafu',
  'jungle.e.divied.coin.anchor': 'Kwa sasa unaweza kushiriki {N} almasi',
  'jungle.e.draw.again': 'Draw tena',
  'jungle.e.draw.time': 'draw*{%d}',
  'jungle.e.event.gift': 'Zawadi ya Tukio',
  'jungle.e.not.start': 'Tukio linaelekea kuanza',
  'jungle.e.ok': 'Sawa',
  'jungle.e.pool.amount': 'Jumla ya Kiasi cha Zawadi',
  'jungle.e.rechrge': 'Rekaji',
  'jungle.e.record': 'Rekodi',
  'jungle.e.sec.tab1': 'Kiwango cha Kuku',
  'jungle.e.sec.tab2': 'Charm Ranking',
  'jungle.e.self.last': '{N} kutoka kwa ile ya awali',
  'jungle.e.send': 'Tuma',
  'jungle.e.send.lock': 'Tuma {N} sarafu zaidi ili kufungua',
  'jungle.e.send.lock.anchor': 'Pokea {N} zawadi zaidi ili kufungua',
  'jungle.e.tab1': 'Changamoto ya Kuku',
  'jungle.e.tab2': 'Kiwango',
  'jungle.e.tab3': 'Maalum ya Lambfold',
  'jungle.e.target': 'Kiwango: {N}',
  'jungle.e.ticket.enough': 'Kadi ya Adventure haitoshi, kamilisha kazi ili kupata zaidi',
  'jungle.e.time': 'Wakati',
  'jungle.e.times': 'Mara X{N}',
  'jungle.e.tip.desc': 'Una zaidi ya {N} sanduku za kuunganisha, unataka kuunganisha sasa?',
  'jungle.e.tool.title': 'Kusanya zana za Kuku',
  'jungle.e.treasure': 'X{N}',
  'jungle.e.wating.unlocked': 'Kiasi cha zawadi kinachohitaji kufunguliwa',
  'jungle.e.win': 'SHINDA',
  'jungle.e.win.desc': 'Hongera kwa kushinda tuzo zifuatazo',
  'jungle.e.winner.list': 'Orodha ya Washindi',
  'kill.monster.congratulations': 'Hongera!',
  'lasser.bairam.collect': 'Kusanya',
  'lasser.bairam.go.look': 'Angalia sasa!',
  'lasser.bairam.next.round': 'Mzunguko ujao',
  'lasser.bairam.no.time.yet': 'Bado si wakati',
  'lasser.bairam.ok': 'Sawa',
  'lasser.bairam.ranking.tab.receive': 'Charm Ranking',
  'lasser.bairam.ranking.tab.send': 'Orodha ya Utajiri',
  'lasser.bairam.rewards.tips': 'Kwa maelezo kuhusu kupata sarafu, tafadhali angalia ukurasa wa sheria.',
  'lasser.bairam.scene.rewards.desc': 'Baada ya kushiriki kufungua eneo la sasa, unaweza kupata zawadi zifuatazo, na MVP ina zawadi za ziada.',
  'lasser.bairam.scene.tips': 'Toa zawadi za kikomo kwenye seva na ufikie idadi inayolingana ya sarafu ili kufungua maeneo na kupata zawadi. MVPs wana zawadi za ziada.',
  'lasser.bairam.scene.unlock.modal.mvp.tag': 'MVP anaweza kupata',
  'lasser.bairam.scene.unlock.modal.title': 'Hongera kwa kushiriki kufungua eneo:',
  'lasser.bairam.scene.unlock.modal.you.can.get': 'Anaweza kupata',
  'lasser.bairam.special.gift.contribution': 'Sanduku la Mchango',
  'lasser.bairam.special.gift.desc': 'Thamani ya zawadi ya kikomo iliyokusanywa iliyopokelewa {%d} sarafu inaweza kushiriki katika uchaguzi wa nyota wa bahati ({%z}/{%m})',
  'lasser.bairam.special.gift.lucky': 'Sanduku la bahati ya eid',
  'lasser.bairam.special.gift.title': 'Sanduku la ziada',
  'lasser.bairam.special.gift.to.be.drawn': 'Ili kuchorwa',
  'lasser.bairam.special.gift.to.complete': 'Kamilisha sasa',
  'lasser.bairam.tab.ranking': 'Kiwango',
  'lasser.bairam.tab.scene': 'Safari ya Eid al-Fitr',
  'lasser.bairam.waiting': 'inasubiri',
  'level.halo': 'Kiwango cha Halo',
  'level.halo.question1.answer1': 'Kiwango cha Juu, Halo Inang\'ara',
  'level.halo.question1.title': 'Faida za Kiwango cha Juu',
  'level.halo.question2.answer1': 'Kiwango cha Juu, Ikoni ya Kipekee Zaidi',
  'level.halo.question2.title': 'Onyesho la Ikoni ya Kiwango',
  'level.halo.question3.answer1': 'Panda Kiwango Ili Kupata Zawadi za Ajabu',
  'level.halo.question3.title': 'Zawadi ya Kupanua Kiwango',
  'level.halo.question4.answer1': 'Pokea zawadi yenye thamani ya 1 sarafu, Pata 1 exp.Kiwango cha juu, Kasi ya kuboresha.',
  'level.halo.question4.title': 'Njia za Kupanda Kiwango',
  'level.user': 'Kiwango cha Mtumiaji',
  'level.user.icon': 'Ikoni',
  'level.user.level': 'Kiwango',
  'level.user.question1.answer1': 'Utapata vitu maalum na zawadi.',
  'level.user.question1.title': 'Faida za Kiwango cha Juu',
  'level.user.question2.answer1': 'Chat ndani ya chumba, cheza michezo na tuma zawadi',
  'level.user.question2.answer2': 'Kamilisha kazi za kila siku, pata uzoefu ili kupanda kiwango',
  'level.user.question2.answer7': 'Fanya sherehe ndani ya chumba',
  'level.user.question2.answer8': 'Tuma zawadi kwa sarafu',
  'level.user.question2.answer9': 'Kamilisha kazi na dai EXP',
  'level.user.question2.title': 'Njia za Kupanda Kiwango',
  'level.user.question3.answer1': 'Kiwango cha juu, Ikoni ya Kipekee Zaidi',
  'level.user.question3.title': 'Onyesho la Ikoni ya Kiwango',
  'level.user.question4.answer1': 'Panda Kiwango Ili Kupata Zawadi za Ajabu',
  'level.user.question4.title': 'Zawadi ya Kupanua Kiwango',
  'level.user.tips': 'Unapoongeza alama za uzoefu, kiwango chako kitaongezeka taratibu',
  'level.user.way.up': 'Njia za kuongeza alama za uzoefu:',
  'like': 'kama',
  'loading': 'Inapakia...',
  'lucky.darw.coin.draw': 'Draw',
  'lucky.darw.coin.more.times': 'mara itagharimu',
  'lucky.darw.coin.more.will.cost': 'itagharimu',
  'lucky.darw.coin.one.times': 'Draw mara 1 inagharimu',
  'lucky.darw.coin.one.times.two': 'Chagua na bonyeza Nenda',
  'lucky.darw.end': 'Tukio haliko katika mchakato',
  'lucky.darw.no.times': 'Idadi ya sasa ya draw haitoshi, nenda kwenye chumba na tuma zawadi',
  'lucky.darw.number': 'idadi ya michoro zangu',
  'lucky.darw.ranking': 'Orodha ya Draw',
  'lucky.darw.reset.time': 'Kukataza',
  'lucky.darw.ruls.1': 'Tuma zawadi ndani ya chumba za mazungumzo na pata nafasi ya kuingia kwenye draw',
  'lucky.darw.ruls.2': 'Kila zawadi ya thamani ya sarafu 5000 inakupa draw 1',
  'lucky.darw.ruls.3': 'Kwa mfano: sarafu 50,000 = michoro 10, sarafu 100,000 = michoro 20. Tuma zawadi zaidi ili kupata michoro zaidi',
  'lucky.darw.ruls.4': 'Ikiwa siku inamalizika na huja tumia michoro zako, michoro zako zote zitakuwa 0 baada ya tukio kumalizika',
  'lucky.darw.title': 'Draw ya Bahati',
  'lucky.darw.use': 'NENDA KUTUMIA',
  'lucky.draw.confirm': 'Tafadhali thibitisha',
  'lucky.draw.confirm.success': 'imefanikiwa',
  'lucky.draw.confirm.text': 'Je, uko tayari kutumia TicketX{%d} kubadilisha?',
  'lucky.draw.exchange.records': 'Rekodi',
  'lucky.draw.exchange.records.commodity': 'bidhaa',
  'lucky.draw.exchange.records.consume': 'tumia',
  'lucky.draw.exchange.records.time': 'wakati',
  'lucky.draw.exchange.shop': 'Duka la Tiketi',
  'lucky.draw.exchange.shop.exchange': 'badilisha',
  'lucky.draw.exchange.shop.val': 'Thamani ya Sarafu{%d}',
  'lucky.draw.may.confirm.text': 'Je, uko tayari kutumia {%s} x{%d} kuchora?',
  'lucky.draw.may.draw.draw.times': 'draw*{%d}',
  'lucky.draw.may.draw.draw.tips': 'tuma zawadi za kikomo kwa {%d} sarafu inaweza kupata nafasi ya kuchora',
  'lucky.draw.may.result.tips': '{%s} itatumika kufungua fumbo',
  'lucky.draw.may.rewards.tips': 'Kwa sheria za kina kuhusu jinsi ya kupata zawadi, tafadhali nenda kwenye ukurasa wa sheria',
  'lucky.draw.may.tab.draw': 'Mecha draw',
  'lucky.draw.may.tab.ranking': 'orodha',
  'lucky.draw.may.tab.vote': 'Nyota ya Mecha',
  'lucky.draw.may.unlock': 'Fungua',
  'lucky.draw.may.unlock.all': 'Asante kwa kufungua fumbo zote, chukua zawadi zote',
  'lucky.draw.may.unlock.some': 'hongera kufungua {%s}%',
  'lucky.draw.may.vote': 'piga kura',
  'lucky.draw.may.vote.cur.ranking': 'orodha ya sasa: {%d}',
  'lucky.draw.may.vote.please.enter.id': 'Tafadhali ingiza id',
  'lucky.draw.may.vote.search.tips': 'Ni waongozi pekee wanaweza kupigiwa kura',
  'lucky.draw.may.vote.tips': 'tuma zawadi za kikomo kwa {%d} sarafu inaweza kupata tiketi 1',
  'lucky.draw.may.vote.top3.tips': 'maelezo zaidi ya zawadi tafadhali pata kwenye ukurasa wa sheria',
  'lucky.draw.may.vote.top3.title': 'zawadi za top3',
  'lucky.draw.may.vote.voting.record': 'Rekodi ya Kupigia Kura',
  'lucky.draw.may.vote.voting.record.number': 'idadi ya kura',
  'lucky.draw.may.vote.voting.record.user': 'mtumiaji',
  'lucky.draw.my.times': 'Mara zangu',
  'lucky.draw.rare': 'Nadhifu',
  'lucky.draw.rules.1': 'Mwisho wa tukio, washindi watatu wa juu watapata tuzo zifuatazo',
  'lucky.draw.rules.2': 'kumbuka: Mwisho wa kampeni, idadi ya zawadi zisizotumika itakuwa 0',
  'lucky.draw.tab.ranking': 'Orodha',
  'lucky.packet.1': 'Tuma pakiti ya bahati',
  'lucky.packet.10': '1. Kifurushi cha bahati chenye nenosiri \n- Unahitaji kutuma nenosiri katika chumba ili kukichukua.',
  'lucky.packet.11': '2. Kifurushi cha bahati kinahitaji wafuasi \n- Unahitaji kumfuata mtumaji wa kifurushi cha bahati ili kukichukua.',
  'lucky.packet.12': 'Masuala ya Kawaida',
  'lucky.packet.13': '1. Wakati pakiti inapoanzisha arifa ya ulimwengu au wakati ikoni ya pakiti ya bahati inaonyeshwa, watu wengine wanaweza kuingia chumbani kwako kwa kubonyeza hiyo.',
  'lucky.packet.14': '2. Ikiwa umefungia chumba chako, arifa ya ulimwengu na ikoni hazitaonekana.',
  'lucky.packet.2': 'Watumiaji wote katika chumba wanaweza kutuma na kudai pakiti ya bahati',
  'lucky.packet.3': 'Wakati kuna pakiti nyingi za bahati katika chumba, zitawekwa pamoja na kuonyeshwa. Pakiti za bahati zinazopelekwa mapema, ndizo zinazoonekana zaidi juu.',
  'lucky.packet.4': 'Vikwazo na Masharti',
  'lucky.packet.5': '1. Inasaidia tu kutuma sarafu.',
  'lucky.packet.6': '2. Mwenendo wa Watu: 3~500.',
  'lucky.packet.7': '3. Kiasi cha kila mtu (kiasi cha sarafu/idadi ya watu) kinahitaji kuwa zaidi ya au sawa na sarafu 1.',
  'lucky.packet.8': '4. Wakati kiasi cha pakiti kinapokuwa zaidi ya sarafu 10000 na idadi ya watu ikiwa zaidi ya 10, itasababisha arifa ya ulimwengu, na ikoni maalum itaonyeshwa kwenye orodha ya chumba.',
  'lucky.packet.9': 'Jinsi ya kucheza',
  'lucky.packet.title': 'Pakiti ya bahati',
  'lucky.recharge.draw.num': 'tiketi zangu za bahati nasibu zilizopo',
  'lucky.recharge.draw.record': 'Tazama rekodi yangu ya ushindi',
  'lucky.recharge.draw.start': 'Anza bahati nasibu',
  'lucky.recharge.hide.info': 'ficha taarifa binafsi',
  'lucky.recharge.recharge.done': 'Umepata tiketi zote za spinner',
  'lucky.recharge.recharge.gift.bag': 'Recharge\npackage',
  'lucky.recharge.recharge.gift.bag.text': 'Recharge {N} kila siku kupata',
  'lucky.recharge.recharge.gift.bag.text.1': 'Tiketi ya bahati nasibu ya zawadi*1',
  'lucky.recharge.recharge.next': 'Recharge {N}<div></div> kupata tiketi {X} za bahati nasibu',
  'lucky.recharge.recharge.no': 'Tiketi za bahati nasibu hazitoshi',
  'lucky.recharge.recharged': 'Imepakiwa tena',
  'lucky.recharge.tab.grid': 'Mshahara wa bahati',
  'lucky.recharge.tab.wheel': 'Gurudumu la bahati',
  'lucky.recharge.ticket': 'tiketi ya bahati nasibu',
  'lucky.recharge.wheel.tip.text.1': 'Kila wakati unapojaza tena kwa kiasi fulani, unaweza kupata tiketi ya bahati nasibu, 100% ya kushinda!',
  'lucky.recharge.wheel.tip.text.2': 'Kadri inavyokuwa na droo nyingi, ndivyo nafasi ya kushinda jackpot inavyoongezeka!',
  'lucky.vs.camp.Eagle': 'Ufunguo wa Tai',
  'lucky.vs.camp.Lion': 'Ufunguo wa Simba',
  'lucky.vs.camp.edit.text.1': 'Badilisha Kambi',
  'lucky.vs.camp.edit.text.2': 'Je, una uhakika unataka kubadilisha kambi? Kila mtu anaweza kubadilisha kambi mara moja tu.',
  'lucky.vs.camp.edit.text.3': 'NDIO',
  'lucky.vs.camp.edit.text.4': 'HAPANA',
  'lucky.vs.camp.join': 'Jiunge',
  'lucky.vs.camp.me': 'Kambi Yetu',
  'lucky.vs.camp.opponent': 'Kambi ya Mpinzani',
  'lucky.vs.camp.select': 'Chaguo la Kambi',
  'lucky.vs.camp.select.text.1': 'Wachangiaji 5 bora wa kambi za ushindi wanaweza kupata zawadi za sarafu!',
  'lucky.vs.camp.select.text.2': 'Ni kambi gani unayotaka kujiunga?',
  'lucky.vs.camp.select.text.3': 'VIDOKEZO: Kila mtu anaweza kubadilisha kambi mara moja tu wakati wa tukio.',
  'lucky.vs.ext.text.tip': 'Fikia {N} sarafu zinaweza kupata zawadi zifuatazo.',
  'lucky.vs.out.tab.left': 'Sanduku la Hazina',
  'lucky.vs.out.tab.right': 'Tai dhidi ya Simba',
  'lucky.vs.reward.extra': 'Tai dhidi ya Simba Bonasi',
  'lucky_daily': 'Kila siku',
  'lucky_faq1': 'Jinsi ya kucheza',
  'lucky_faq10': 'Mzunguko wa Takwimu',
  'lucky_faq11': 'Uainishaji wa kila siku: data kutoka 0:00 hadi 24:00 kila siku',
  'lucky_faq12': 'Uainishaji wa kila wiki: data kutoka saa 0:00 kila Jumatatu hadi saa 24:00 Jumapili',
  'lucky_faq13': '3. Zawadi za Nafasi',
  'lucky_faq14': 'Waliokuwepo katika nafasi kumi bora katika viwango vya kila siku na kila wiki watapata zawadi kama ilivyoonyeshwa hapa chini.',
  'lucky_faq15': 'Zawadi za uainishaji wa kila siku',
  'lucky_faq16': 'Uainishaji',
  'lucky_faq17': 'Tuzo za uainishaji wa kila wiki',
  'lucky_faq2': 'Sheria za Mchezo',
  'lucky_faq3': '1. Baada ya kutoa zawadi ya bahati, una nafasi ya kupata tuzo ya sarafu za dhahabu mara 1-1000;',
  'lucky_faq4': '2. Kadri unavyotuma zawadi nyingi za bahati katika Combo au Batch, ndivyo nafasi ya kushinda inavyokuwa kubwa;',
  'lucky_faq5': '3. Zawadi za sarafu za dhahabu zitasambazwa kwenye salio la akaunti mara moja, na maelezo ya ushindi yanaweza kuonyeshwa katika rekodi ya zawadi ya bahati;',
  'lucky_faq6': 'Kila wakati zawadi ya bahati inatolewa, nanga pia itapata sehemu fulani ya almasi.',
  'lucky_faq7': 'Sheria za Uainishaji',
  'lucky_faq8': '1. Kanuni za Takwimu',
  'lucky_faq9': 'Watumiaji kumi wanaotumia sarafu za dhahabu nyingi zaidi kushiriki katika michezo ya kila siku na ya kila wiki watakuwa kwenye orodha ya matajiri, na watumiaji kumi wenye viwango vya juu zaidi vya kushinda watakuwa kwenye orodha ya bahati.',
  'lucky_list': 'Mshindi wa Bahati',
  'lucky_weekly': 'Wikendi',
  'miss': 'Almasi Ilipotea',
  'missToday': 'Kukosa-Leo',
  'modalBtn': 'Endelea Kuongea',
  'modalIncome': 'Kiwango cha Mapato',
  'modalReward': 'Zawadi za ziada',
  'modalRound': 'Mizunguko ya mazungumzo',
  'modalSpeed': 'Kasi ya majibu',
  'modalTips': 'Haraka unavyopiga majibu kwa ujumbe, ndivyo itakavyoboresha uzoefu wa mtumiaji, na ndivyo utakavyopata almasi zaidi.',
  'modalTipsTwo': 'Ubora wa juu wa maudhui ya majibu yako na mizunguko zaidi ya mazungumzo utaimarisha uzoefu wa mtumiaji, na zaidi ya almasi unazopata:',
  'month': 'Mwezi',
  'month.select': 'Chagua Mwezi',
  'month.select.day': 'Chagua Tarehe',
  'more': 'zaidi',
  'my.earning.daimonds': 'almasi',
  'my.earning.salary.rules': 'Sheria za Mishahara',
  'my.earning.tips': 'Usawa wa almasi',
  'my.earning.title': 'Mwanzo wangu',
  'my.earning.withdrawal.rules': 'Sheria za Uondoaji',
  'new.ranking.list.charm': 'Uhaishaji',
  'new.ranking.list.contribution': 'Mchango',
  'new.ranking.list.record': 'Kumbukumbu',
  'new.task.done': 'Imekamilika',
  'new.task.go': 'Nenda',
  'noble_introduce_1': '1. Nini maana ya Aristokrasia?',
  'noble_introduce_2': '2.Jinsi ya kuwa aristokrate',
  'noble_introduce_3': '3. Hesabu ya muda wa uhalali',
  'noble_introduce_4': '4. Maagizo ya usambazaji wa sarafu za kila siku',
  'noble_introduce_5': 'Punguzo la ununuzi wa kuendelea',
  'noble_introduce_6': 'Kuwezesha Jumba la Wakuu',
  'noble_introduce_7': '7. Sending the Kingdom as a gift',
  'noble_introduce_text1': 'Ukoo ni alama maalum ya hadhi na umegawanywa katika ngazi saba za hadhi, yaani knight, baron, viscount, earl, marquis, duke na mfalme. Ngazi tofauti za ukoo zinanufaika na faida tofauti.',
  'noble_introduce_text2': 'Ufalme unaweza kununuliwa kwa kuongeza sarafu za dhahabu, na ununuzi unaweza kukamilishwa kwa kuchagua kiwango kinacholingana kwenye ukurasa wa Ufalme. Wakati huo huo, unaweza pia kupata hadhi ya kifahari kupitia zawadi kutoka kwa wengine.',
  'noble_introduce_text3': 'Hadhi ya aristocracy ni halali kwa siku 30 kuanzia tarehe ya ununuzi, na utafurahia faida za aristocracy wakati wa kipindi cha uhalali. Faida hizo zitakoma mwishoni mwa kipindi cha uhalali.',
  'noble_introduce_text4': 'Baada ya kununua Aristocracy kwa kutumia sarafu za dhahabu, unastahili kupokea sarafu za dhahabu kama zawadi kila siku. Utapokea sarafu za dhahabu baada ya kuingia kila siku. Ikiwa hujaingia siku hiyo, hautaweza kupata sarafu za dhahabu za siku hiyo. Unapotoa Aristocracy kwa wengine, mpokeaji atapata haki ya kupokea sarafu za kila siku.',
  'noble_introduce_text5': 'Wakati wa kupata hadhi ya aristocratic, na ndani ya siku 10 baada ya hadhi ya aristocratic kumalizika, hadhi hiyo hiyo inaweza kununuliwa tena kwa bei nzuri zaidi. Mpango huu si wa kiotomatiki na unahitaji kununuliwa kwa mikono ili uanze kufanya kazi.',
  'noble_introduce_text6': 'Unapokuwa na hadhi ya aristocracy, unaweza kununua aristocracy ya kiwango cha juu na moja kwa moja kupata manufaa mapya. Siku zilizobaki za aristocracy iliyopo zitajumuishwa kwenye kiwango kipya kulingana na thamani iliyobaki, na kipindi cha uhalali cha kiwango kipya cha aristocracy kitatunzwa.',
  'noble_introduce_text7': 'Wakati wa kumkabidhi mtu mwingine aristocracy, bei ya awali itatolewa kwa mtu huyo, na mpokeaji atafaidika na sarafu za kila siku na haki nyingine zinazohusiana na kiwango. Ikiwa mpokeaji tayari ana hadhi ya aristocratic, atafaidika moja kwa moja na hadhi ya juu ya aristocratic, na viwango vingine vitabadilishwa kulingana na muda unaohusiana.',
  'noble_introduce_title': 'Utangulizi wa Kanuni za Aristokrasia',
  'noble_introduce_welcome': 'Karibu kujiunga na mfumo wetu wa aristocratic! Kuwa aristocrat kutakuruhusu kufurahia faida na priviliji za kipekee zaidi. Ifuatayo ni utangulizi wa kusaidia kuhusu mfumo wetu wa aristocratic:',
  'payment_bind_1': 'Akounti',
  'payment_bind_10': 'Uondoaji umefanikiwa',
  'payment_bind_11': 'Jina la kwanza/Jina la kuzaliwa',
  'payment_bind_12': 'Jina la familia',
  'payment_bind_13': 'Anwani ya Mkataba',
  'payment_bind_14': 'Epay Barua Pepe',
  'payment_bind_15': 'Kumbuka: Itifaki ya TRC-20',
  'payment_bind_16': 'Kumbuka: Hakikisha akaunti yako ya Epay imethibitishwa.',
  'payment_bind_17': 'Anwani ya mkataba inaanza na T',
  'payment_bind_18': 'Haiwezi kuzidi herufi 40',
  'payment_bind_19': 'Lazima iendane na barua pepe ya akaunti yako ya Epay.',
  'payment_bind_2': 'Kadi ya benki',
  'payment_bind_20': 'Ingiza anwani ya barua pepe',
  'payment_bind_21': 'Akaunti ya Gcash',
  'payment_bind_22': 'Lazima iwe na tarakimu 11 ikianza na 09',
  'payment_bind_23': 'Ruhusu herufi za Kiingereza pekee, nafasi, viungio (-), nukta (.), na koma (,) na zisizidi herufi 100.',
  'payment_bind_24': 'Uhamisho wa Benki akaunti',
  'payment_bind_2_GPAY': 'Kadi ya benki',
  'payment_bind_3': 'Jina la benki',
  'payment_bind_4': 'Jina',
  'payment_bind_5': 'Barua',
  'payment_bind_6': 'Anwani',
  'payment_bind_7': '10 nambari au PL pamoja na nambari 10',
  'payment_bind_8': 'Inaanza na TR + tarakimu 24',
  'payment_bind_9': '{n} Lazima',
  'profit': 'Takwimu za Mapato',
  'program_faq_10': 'Kila mtu katika chumba anaweza kufikia ratiba ya programu kwa kubofya kwenye kona ya juu kulia na kuonyesha msaada kwa programu zao wanazozipenda kwa kubofya \'Nina nia\' au \'Tuma Zawadi\' ili kuongeza umaarufu wa programu hiyo.',
  'program_faq_11': 'Futa programu au funga ratiba ya programu.',
  'program_faq_12': 'Mmiliki wa chumba au msimamizi anaweza kusogeza kushoto kwenye programu na kubonyeza \"Futa\" ili kuondoa programu hiyo. Ratiba ya programu itajifunga kiotomatiki baada ya siku 7, lakini mwenyeji au msimamizi pia anaweza kuifunga kwa mikono. Kufuta programu au kufunga ratiba ya programu kutafuta data ya umaarufu wa programu.',
  'program_faq_13': 'Vidokezo',
  'program_faq_13_ios': 'Vidokezo',
  'program_faq_14': 'Ratiba ya programu inaruhusu kuongeza programu 15 kwa kiwango cha juu.',
  'program_faq_15': '2. Ratiba ya programu ambayo imekosa kupitia mchakato wa ukaguzi haiwezi kufunguliwa.',
  'program_faq_16': 'Mpango wa ratiba utafungwa kiotomatiki baada ya siku 7 tangu ufunguliwe.',
  'program_faq_2': 'Ratiba ya Mpango Utangulizi',
  'program_faq_3': 'Ili kuboresha burudani na mwingiliano, tunatoa kipengele cha ratiba ya programu. Ratiba ya programu hufanya kama muonekano wa programu zijazo za chumba. Waangalizi wanaweza kupiga kura na kutuma zawadi kulingana na ratiba ya programu, wakionyesha mapendeleo yao na shauku yao kwa programu za chumba.',
  'program_faq_4': 'Ratiba ya Programu Kuingia',
  'program_faq_5': 'Mmiliki wa chumba au msimamizi anaweza kufikia ratiba ya programu kupitia menyu ya Mipangilio. Wawezeshi wanaweza kuingia katika ratiba ya programu kwa kubofya kwenye kona ya juu kulia ya chumba wakati programu inapoendelea.',
  'program_faq_6': 'Jinsi ya Kuweka Ratiba ya Programu',
  'program_faq_7': 'Bonyeza \"Ongeza Programu\" na uingize jina la programu unayotaka kutekeleza.',
  'program_faq_8': 'Baada ya kuunda na kupitia ratiba ya programu, bonyeza \"Anza Ratiba ya Programu\" ili iweze kuonekana kwa hadhira. Mara itakapowezeshwa, watazamaji wataweza kuona ratiba ya programu.',
  'program_faq_9': 'Jinsi ya Kuingiliana na Ratiba ya Programu',
  'program_faq_part1': 'SEHEMU1',
  'program_faq_part2': 'SEHEMU YA PILI',
  'program_faq_part3': 'SEHEMU3',
  'program_faq_part4': 'SEHEMU YA 4',
  'program_list_24_ios': 'Futa',
  'pull.refresh.activate': 'Achilia ili kuimarisha',
  'pull.refresh.deactivate': 'Buruza ili kuweza kuhuisha',
  'pull.refresh.release': 'Inapakia zaidi',
  'push.refresh.activate': 'Inapakia zaidi',
  'push.refresh.noMore': 'Hakuna taarifa zaidi',
  'quality': 'Ubora wa mazungumzo',
  'quickCall': 'Ratings za Watumiaji <br /> kwa Wito wa Haraka na ankara',
  'quickCall1': 'Madirisha ya Mtumiaji <br /> kwa Simu ya Haraka nami',
  'ramadan.new.back': 'Nyuma',
  'ramadan.new.bottom.desc': 'Recharge mara moja kwa siku na unaweza kujiandikisha tena mara moja.',
  'ramadan.new.collect': 'Kusanya',
  'ramadan.new.collected': 'Kukusanya',
  'ramadan.new.estimated.win': 'Makadirio ya ushindi',
  'ramadan.new.event.start': 'Tukio linaanza hivi karibuni.',
  'ramadan.new.had.sign': 'Umejiandikisha tena leo.',
  'ramadan.new.honor.countdown.ing': 'Kuhesabu nyuma',
  'ramadan.new.honor.countdown.over': 'Tukio limeisha.',
  'ramadan.new.honor.countdown.waiting': 'Tukio linaanza hivi karibuni.',
  'ramadan.new.honor.desc': 'Kipengele cha heshima ya chumba kitazinduliwa mara moja kwa kila {N} zawadi za kikomo katika majukwaa yote.',
  'ramadan.new.honor.my.times': 'Wakati Wangu',
  'ramadan.new.honor.time': '{N}wakati',
  'ramadan.new.honor.times': '{N}mara',
  'ramadan.new.honor.toTop1.time': 'UP NEED <span class=\'span\'> {N} </span> WAKATI',
  'ramadan.new.honor.toTop1.times': 'UP NEED <span class=\'span\'> {N} </span> MARA',
  'ramadan.new.my.tickets': 'Tiketi Zangu',
  'ramadan.new.next': 'IJAYO',
  'ramadan.new.nickname': 'Jina la utani',
  'ramadan.new.not.remain': 'Usiionyeshe tena.',
  'ramadan.new.ok': 'Sawa',
  'ramadan.new.prize.content': 'Umepokea',
  'ramadan.new.rank.daily': 'Uainishaji wa Kila Siku',
  'ramadan.new.rank.daily.desc': 'Kila siku, mtumiaji wa TOP1 anaweza kupata zawadi zinazofanana.',
  'ramadan.new.rank.tab.give': 'Ufunguo wa Utajiri',
  'ramadan.new.rank.tab.receive': 'Ushindi wa Kivutio',
  'ramadan.new.rank.tips': 'Hatua hii inaelekea kuanza.',
  'ramadan.new.rank.total': 'Ushindi Jumla',
  'ramadan.new.resign.btn': 'Re-Sign In: Ingia Tena',
  'ramadan.new.resign.content': 'Urejeleaji wa mafanikio unapata:',
  'ramadan.new.resign.fail.btn': 'Rejesha Sasa',
  'ramadan.new.resign.fail.content': 'Recharge mara moja kwa siku na unaweza kujiandikisha tena mara moja. (Sarafu zinazonunuliwa kutoka kwa wauzaji zitahesabiwa; ununuzi kutoka kwenye jukwaa na wauzaji hautahesabiwa.)',
  'ramadan.new.sign.day': 'Ingia kwa {N} siku',
  'ramadan.new.tab1': 'Usajili wa Ramadhani',
  'ramadan.new.tab2': 'Kiwango cha Maombi',
  'ramadan.new.tab3': 'Baraka Heshima',
  'ramadan.new.today.content': 'Ingiza leo unaweza kupata:',
  'ramadan.new.waiting': 'Kungoja',
  'ranking.blank.daily': 'Hakuna mtu aliyepatia zawadi leo.',
  'ranking.blank.weekly': 'Hakuna mtu aliyepatia zawadi katika wiki hii.',
  'ranking.contributed': 'Imetolewa:',
  'ranking.daily': 'Kila siku',
  'ranking.weekly': 'Kila wiki',
  're_signing': 'Kusaini tena',
  'reached': '🙋‍♀️ Idadi ya watumiaji',
  'recharge.event.Recharge': 'Rekaji',
  'recharge.event.amount.reached': 'Kiasi cha sarafu kilifikia',
  'recharge.event.done': 'Hongera! Umefikia kiwango cha juu kabisa! Furahia zawadi zako sasa!',
  'recharge.event.group': 'Kikundi',
  'recharge.event.hidden': 'Ficha taarifa',
  'recharge.event.next.1': 'Tuahitaji tu',
  'recharge.event.next.2': 'sarafu kufikia kiwango kilichofuata',
  'recharge.event.ranking.list': 'Orodha ya Nafasi',
  'recharge.event.rewards.for': 'Tuzo kwa',
  'recharge.event.tab.1': 'Usasishaji wa Malipo',
  'recharge.event.trouble': 'Je, una shida na kuchaji?',
  'recharge.result.pending': 'Utekelezaji umekamilika',
  'recharge.result.tips': 'Ikiwa sarafu hazitafika kwa wakati, tafadhali usijali, kunaweza kuwa na ucheleweshaji wa mtandao. Ikiwa una maswali yoyote, tafadhali wasiliana na huduma rasmi ya wateja wa Soyou.',
  'recharge.result.tips.click': 'Bonyeza kurudi kwenye APP',
  'retry': 'Jaribu tena',
  'rich_list': 'Rich Ranking',
  'roundTitle': 'Sheria za Mapato ya Kizunguzungu',
  'share.download': 'Pakua',
  'share.install': 'Sakinisha programu ya Redio ya Soundi sasa.',
  'share.live': 'ishi',
  'share.ok': 'Sawa',
  'share.play': 'Piga kwenye Redio ya Soundi',
  'share.whatsapp.tip': 'WhatsApp huenda haijasanidiwa kwenye simu yako, ipewe na ujaribu tena.',
  'share_text100': 'Kopiwa',
  'share_text23': 'Pakua',
  'share_text24': 'Jiunge na chumba',
  'share_text25': 'Niko kwenye chumba hiki, njoo ujiunge nasi.',
  'share_text26': 'Nambari ya Chumba',
  'sign_in_text3_new': 'Ingia 2x tuzo',
  'speed': 'Majibu ya kasi',
  'speed.passion.Completed': 'Imekamilika',
  'speed.passion.Daily.Rewards': 'Mikopo ya Kila Siku',
  'speed.passion.Done': 'Imekamilika',
  'speed.passion.Result': 'Matokeo',
  'speed.passion.Result.lose': 'Hakuna timu iliyo shinda jana, hivyo hebu jaribu tena leo.',
  'speed.passion.Result.ps': 'PS: Ni MVP pekee wa kikundi kinachoshinda atapata zawadi za ziada!',
  'speed.passion.Result.win': 'Hongera kwa jana {N} kwa kuja wa kwanza, chukua hizi zawadi!',
  'speed.passion.change': 'kubadilisha',
  'speed.passion.change.change.desc': 'Je, unataka kubadilisha kwenda kwenye kundi hili?',
  'speed.passion.change.change.group': 'Badilisha kundi',
  'speed.passion.change.change.ps': 'PS: Zawadi zote za kikundi hiki hazitapatikana baada ya kubadilisha kikundi.',
  'speed.passion.choice.group': 'Chagua kundi',
  'speed.passion.choice.group.desc': 'Ilipatikana baada ya kujiunga na kundi',
  'speed.passion.daily.task': 'kazi ya kila siku',
  'speed.passion.go.for.it': 'Nenda kwa hilo',
  'speed.passion.limited.desc': 'Watumiaji waliopewa majina wanapata {N}x maili wanapotuma zawadi yao ya jina.',
  'speed.passion.naming.desc': 'Mtumiaji anayepeleka zawadi hii mara nyingi zaidi wakati wa tukio ataitwa zawadi hii wiki ijayo!',
  'speed.passion.naming.progress': 'Iliyoitwa maendeleo',
  'speed.passion.naming.progress.get.the.number': 'Pata nambari',
  'speed.passion.naming.progress.no.one.get': 'Hakuna mtu yeyote aliye na ufikiaji wake bado, hivyo jiunge!',
  'speed.passion.naming.unnamed': 'bila jina',
  'speed.passion.race': 'Mbio',
  'speed.passion.rank.Mileage': 'Mtindo wa kilomita:',
  'speed.passion.rank.daily': 'kila siku',
  'speed.passion.rank.no.rank': 'Kikundi changu',
  'speed.passion.rank.not.time': 'Bado si wakati.',
  'speed.passion.rank.total': 'jumla',
  'speed.passion.ranking': 'Uwekaji wa viwango',
  'speed.passion.winning.TOP1': 'Kushinda Top1',
  'speedTitle': 'Jibu kwa Kanuni za Mapato ya Ujumbe',
  'spring.cp.cruise.bless': 'Bonyeza kubariki',
  'spring.cp.cruise.bless.click.desc': 'Bofya {N} mara itamletea {name} {time}',
  'spring.cp.cruise.bless.my.times': 'wakati wangu',
  'spring.cp.cruise.bless.status.1': 'Kupokelewa',
  'spring.cp.cruise.bless.status.2': 'Isiyodaiwa',
  'spring.cp.cruise.find.my.cp': 'Pata CP yangu',
  'spring.cp.cruise.my.cp': 'cp yangu',
  'spring.cp.cruise.rule.tips': 'CP anayepewa maua mengi zaidi kwa kutuma zawadi chache kwa kila mmoja wakati wa tukio anaweza kuandaa harusi ya meli tarehe 2.14.',
  'spring.cp.no.cp': 'Haukupeleka zawadi iliyozuiliwa.',
  'spring.cp.no.people': 'Kusubiri',
  'spring.cp.rewards.wedding.tips': 'Watumiaji wawili wanaofanya harusi wanaweza kupata avatar ya muda mfupi* siku 30.',
  'spring.cp.tab.cruise.ranking': 'Harusi ya meli',
  'spring.cp.tab.rose.ranking': 'Ufunguo wa Rose',
  'spring.cp.tab.rose.ranking.daily': 'Uainishaji wa kila siku',
  'spring.cp.tab.rose.ranking.daily.tips': 'Kutuma zawadi hii kunaweza kupata {%d}% zaidi ya maua ya rose leo.',
  'spring.cp.tab.rose.ranking.daily.toast': 'Tarehe haijafika.',
  'spring.cp.tab.rose.ranking.total': 'Ushindani wa jumla',
  'spring.cp.wait.wedding': 'Harusi inaanza tarehe 14 Februari.',
  'svip_introduce_1': '1. SVIP ni nini',
  'svip_introduce_2': '2. Jinsi ya kuwa SVIP',
  'svip_introduce_3': '3. Jinsi ya kuhesabu muda wa uhalali wa SVIP',
  'svip_introduce_4': '4. Kushushwa na kudorora kwa SVIP',
  'svip_introduce_5': '5. Haki na maslahi ya SVIP',
  'svip_introduce_text1': 'SVIP ni mfumo wa viwango vya kipekee wa jukwaa. Kuna viwango 8 kwa jumla, SVIP1-SVIP8. Kadri kiwango kinavyopanda, ndivyo hadhi inavyokuwa ya kipekee zaidi, na unavyonufaika na haki na maslahi ya juu zaidi.',
  'svip_introduce_text2': 'Unaweza kupata pointi za uzoefu wa SVIP kwa kuongeza sarafu za dhahabu, sarafu 1 ya dhahabu = pointi 1 za uzoefu. Wakati pointi za uzoefu zinapofikia viwango tofauti vya SVIP, unaweza kupata kiwango husika cha SVIP.',
  'svip_introduce_text31': 'SVIP inachukua kila mwezi wa asili kama mzunguko, na tarehe 1 ya kila mwezi wa asili, pointi za uzoefu za SVIP zinakusanywa kutoka 0. Kiwango husika cha SVIP kitapatikana kulingana na kiwango kilichofikiwa na thamani ya uzoefu wa SVIP.',
  'svip_introduce_text32': 'Kuanzia wakati unapata hadhi ya SVIP, hadhi yako na haki zitahifadhiwa hadi mwisho wa mwezi ujao. (Kwa mfano: ikiwa SVIP3 inapatikana tarehe 18 Mei, basi hadhi ya SVIP3 itapanuliwa hadi tarehe 30 Juni.)',
  'svip_introduce_text33': 'Ikiwa thamani yako ya uzoefu wa SVIP inafikia kiwango cha juu ndani ya mwezi wa kawaida, itasasishwa mara moja. (Kwa mfano: ikiwa unafikia SVIP3 tarehe 18 Mei na SVIP4 tarehe 25 Mei, utapata hadhi ya SVIP4 mara moja tarehe 25 Mei na kuendelea hadi mwisho wa tarehe 30 Juni.)',
  'svip_introduce_text34': 'Mwezi wa asili ukimalizika, utambulisho na haki zitabaki, lakini pointi za uzoefu za SVIP kwa mwezi ujao zitaanzia 0. (Kwa mfano: Ikiwa unafikia SVIP4 tarehe 25 Mei, bado utafurahia utambulisho na haki za SVIP4 katika mwezi wa Juni, lakini utaanza kukusanya pointi za uzoefu za SVIP kutoka 0 mwezi wa Juni)',
  'svip_introduce_text41': 'Mwanzo wa kila mwezi wa asili, ikiwa una kiwango cha SVIP na unataka kuendelea na kiwango hiki cha SVIP katika mwezi unaofuata, unahitaji kufikia 50% ya thamani ya uzoefu wa kiwango cha SVIP kabla ya kumalizika kwa mwezi wa asili, yaani, unaweza kuendelea na kiwango hiki katika mwezi unaofuata, kudumisha utambulisho na haki. (Kwa mfano: wakati Mei inaanza, wewe ni SVIP4, basi unahitaji kufikia 50% ya thamani ya uzoefu ya kiwango cha SVIP4 wakati wa Mei ili kudumisha kiwango cha SVIP4 hadi mwisho wa Juni.)',
  'svip_introduce_text42': 'Ikiwa 50% ya thamani ya uzoefu wa kiwango cha SVIP haijafikiwa ndani ya mwezi wa kawaida, itapunguzwa kwa kiwango 1 mwezi unaofuata. (Kwa mfano: mwanzoni mwa Mei, uko SVIP4, na thamani ya uzoefu katika Mei nzima haifikii 50% ya kiwango cha SVIP4, basi Juni itashuka kwa kiwango 1, ikianza kutoka SVIP3.)',
  'svip_introduce_text43': 'Ikiwa hakuna alama za uzoefu za SVIP zinazozalishwa ndani ya mwezi wa kawaida, kiwango cha SVIP kitaanguka kwa viwango 3 katika mwezi unaofuata. (Kwa mfano: unapofikia Mei ukiwa na SVIP4, na hakuna alama za uzoefu zinazozalishwa wakati wote wa Mei, basi Juni kitaanguka kwa viwango 3, kuanzia SVIP1)',
  'svip_introduce_text5': 'Kadri kiwango cha SVIP kinavyoongezeka, ndivyo haki unazofurahia zinavyoongezeka. Wakati kiwango kinabadilika, utafurahia faida za kiwango kipya, na zawadi za mali unazopokea zitaandikwa upya na kiwango kipya. Unapoboresha au kudumisha mali zilizobinafsishwa, unahitaji kuwasiliana na huduma kwa wateja mwenyewe na kuweka mahitaji ya ubinafsishaji kabla ya kutolewa. Hata hivyo, hazitatoa ikiwa utashuka kiwango.',
  'svip_introduce_title': 'Utangulizi wa sheria za SVIP',
  'svip_introduce_welcome': 'Karibu kuwa SVIP! SVIP itakuruhusu kufurahia manufaa zaidi. Hapa kuna utangulizi wa msaada kuhusu SVIP:',
  'svip_table1': 'Kiwango cha SVIP',
  'svip_table2': 'Ujumbe wa bure',
  'svip_table3': 'Mawasiliano bure',
  'task.center.common.level': 'Kiwango',
  'task.center.limit.Diamonds.Received': 'Almasi Zilizopokelewa',
  'task.center.limit.Reward.Received': 'Tuzo Iliyopokelewa',
  'task.center.limit.Total': 'Jumla',
  'task.center.limit.extra': 'Zaidi',
  'task.center.limit.receive': 'Pokea',
  'task.center.limit.task': 'Kazi Iliyopangwa',
  'task.center.limit.to.start': 'Tukio halijaanza bado.',
  'task.center.limit.today': 'Leo',
  'task.center.normal.task': 'Kazi ya Kawaida',
  'task.center.title': 'Kituo cha Kazi',
  'task_miss': 'kosa',
  'task_txt21': 'Kukagua kila siku',
  'task_txt22': 'siku',
  'task_txt23': 'Ingia',
  'task_txt24': 'orodha ya kazi',
  'task_txt25': 'Majukumu ya msingi',
  'task_txt31': 'Imesainiwa ndani',
  'tips': 'Hakuna data zaidi',
  'to.exchange.page.button': 'Badilisha',
  'total.rank.daily': 'Kila siku',
  'total.rank.day': 'Kila siku',
  'total.rank.gap': 'Pengo{X}',
  'total.rank.gift': 'WIKI YA NYOTA',
  'total.rank.help': '<h1>Aina ya Uwekaji</h1>\n<p>Daraja &lt;Chumba&gt;: Wakati wa muda huu, vyumba vyote vitawekwa kulingana na kiasi cha sarafu za zawadi zilizotumwa katika chumba.</p>\n<p>Daraja &lt;MPELEKEZI&gt;: Wakati wa muda huu, watumiaji wote watawekwa kulingana na kiasi cha sarafu za zawadi zilizotumwa na mtumiaji.</p>\n<p>Daraja &lt;MVUTI&gt;: Wakati wa muda huu, watumiaji wote watawekwa kulingana na kiasi cha sarafu za zawadi ulizopokea.</p>\n<h1>Wakati wa Uwekaji</h1>\n<p>Zamu ya uwekaji kawaida ni masaa, siku, wiki, na miezi.</p>\n<p>Daraja linaonyesha 3 bora za kipindi kilichopita, pamoja na 50 bora za kipindi cha sasa, ikisasishwa kwa wakati halisi.\n(Kwa kuchelewa chini ya dakika 1)</p>\n<p>Wakati wa Kurekebisha (UTC+3): Kurekebisha Daraja la Kila Siku kunafanyika saa 11 alfajiri; Kurekebisha Daraja la Kila Wiki kunafanyika saa 11 alfajiri kila Jumatatu; Kurekebisha Daraja la Kila Mwezi kunafanyika saa 11 alfajiri tarehe 1 ya kila mwezi.</p>\n<h1>Ulinzi wa Faragha</h1>\n<p>Baadhi ya Daraja hayatatoa nambari maalum;</p>\n<p>Hata hivyo, tofauti kati ya uwekaji wa awali inaonyeshwa;</p>\n<p>3 bora hazitaonyesha tofauti kati yao.</p>',
  'total.rank.help.eu': '<h1>Aina ya Uorodheshaji</h1>\n<p>Uorodheshaji &lt;GIFT&gt;: Wakati wa kipindi hiki, watumiaji wote wataorodheshwa kulingana na kiasi cha sarafu za zawadi zilizotumwa na mtumiaji.</p>\n<p>Uorodheshaji &lt;CHARMER&gt;: Wakati wa kipindi hiki, watumiaji wote wataorodheshwa kulingana na kiasi cha sarafu za zawadi ulizopokea.</p>\n<h1>Mzunguko wa Wakati wa Uorodheshaji</h1>\n<p>Uorodheshaji unaonyesha 3 bora za mzunguko wa awali, pamoja na 50 bora za mzunguko wa sasa, ikisasishwa kwa wakati halisi.\n(Kwa ucheleweshaji wa chini ya dakika 1)</p>\n<p>Wakati wa Kusasisha (UTC+3): Uwasilishaji wa Uorodheshaji wa Kila Siku unafanywa saa 11 alfajiri; Uwasilishaji wa Uorodheshaji wa Kila Wiki unafanywa saa 11 alfajiri kila Jumatatu; Uwasilishaji wa Uorodheshaji wa Kila Mwezi unafanywa saa 11 alfajiri tarehe 1 ya kila mwezi.</p>\n<h1>Kulinda Faragha</h1>\n<p>Baadhi ya Uorodheshaji hautaonyesha nambari maalum;</p>\n<p>Hata hivyo, tofauti kati ya uorodheshaji wa awali inaonyeshwa;</p>\n<p>3 bora hazitaonyesha tofauti kati yao.</p>',
  'total.rank.help.eu.ios.hide': '<h1>Daraja Wakati Mzunguko</h1>\n<p>Daraja linaonyesha 3 bora za mzunguko uliopita, pamoja na 50 bora za mzunguko wa sasa, ikisasishwa kwa wakati halisi. \n(Pamoja na ucheleweshaji wa chini ya dakika 1)</p>\n<p>Wakati wa Kurefresh (UTC+3): Kurefresh kwa Daraja la Kila Siku kunafanyika saa 11 jioni; Kurefresh kwa Daraja la Kila Wiki kunafanyika saa 11 jioni kila Jumatatu; Kurefresh kwa Daraja la Kila Mwezi kunafanyika saa 11 jioni tarehe 1 ya kila mwezi.</p>\n<h1>Kulinda Faragha</h1>\n<p>Baadhi ya Daraja hayatonyesha nambari maalum;</p>\n<p>Hata hivyo, tofauti kati ya kiwango kilichopita inaonyeshwa;</p>\n<p>3 bora haitonyesha tofauti kati yao.</p>',
  'total.rank.help.title': 'Sheria za Uainishaji',
  'total.rank.hide': 'Ficha katika Daraja',
  'total.rank.hide.info': 'Habari Zilizofichwa',
  'total.rank.hide.name': 'Bwana Siri',
  'total.rank.hour': 'Masaa',
  'total.rank.last.day': 'Siku ya Mwisho TOP3',
  'total.rank.last.hour': 'Saa ya Mwisho TOP3',
  'total.rank.last.month': 'Mwezi uliopita TOP3',
  'total.rank.last.week': 'Wiki iliyopita TOP3',
  'total.rank.month': 'Kila mwezi',
  'total.rank.room': 'CHUMBA',
  'total.rank.sent': 'MPELEKEZI',
  'total.rank.this.day': 'Hii Siku',
  'total.rank.this.hour': 'Saa Hii',
  'total.rank.this.month': 'Mwezi huu',
  'total.rank.this.week': 'Wiki hii',
  'total.rank.week': 'Wiki moja',
  'viewMore': 'Tazama zaidi',
  'vip.help.1': 'Sheria za VIP',
  'vip.help.10': 'Ikiwa thamani yako ya EXP iliyokusanywa inafikia mahitaji ya kiwango chako cha sasa cha VIP katika mwezi huu, utaendelea kuwa na kiwango chako cha VIP katika mwezi ujao; la sivyo, kiwango chako cha VIP kitaangaziwa mwezi ujao. Kwa mfano: ikiwa wewe ni VIP5 mwezi Mei, lakini umekusanya tu VIP3 mwezi Mei, basi kiwango chako cha VIP kitaangaziwa kuwa VIP3 kuanzia mwezi Juni.',
  'vip.help.11': 'Kiwango cha Rebate cha VIP',
  'vip.help.12': 'Kulingana na Kiwango cha VIP siku ya 1 ya kila mwezi, tutawatumia watumiaji kiasi fulani cha VIP EXP kulingana na Viwango vyao vya VIP siku ya 1 ya kila mwezi.',
  'vip.help.13': 'Kiwango',
  'vip.help.14': 'Thamani ya EXP Kipindi',
  'vip.help.15': 'Thamani ya EXP Rejea',
  'vip.help.2': 'Ni nini VIP?',
  'vip.help.3': 'VIP ni darasa maalum katika Soyou. Inajumuisha viwango 11 vya utambulisho. Unaweza kuwa na haki zinazofanana baada ya kumiliki VIP.',
  'vip.help.4': 'Jinsi ya kuboresha kiwango cha VIP?',
  'vip.help.5': '1. Kujaza $1 kunaweza kupata 1 VIP EXP.</br>\n2. Kiwango chako cha VIP kitainuliwa mara moja wakati VIP EXP inafikia mahitaji ya kuimarisha katika mwezi huo.</br>\n3. Kuanzia siku ya 1 ya kila mwezi, EXP ya awali ya kila mtu itarudishwa kuwa 0. Na kiwango chako cha VIP kitamuliwa na kiasi kilichokusanywa cha EXP.',
  'vip.help.6': 'Sasisha Sheria za Kiwango cha Vip',
  'vip.help.7': 'Kanuni za Uboreshaji',
  'vip.help.8': 'Mara tu unapotimiza masharti ya kuboresha mwezi huu, kiwango chako cha VIP kitasasishwa mara moja. Na kiwango cha VIP kitaendelea hadi mwisho wa mwezi ujao. Kwa mfano, mtumiaji alifikia VIP5 tarehe 10 Machi na VIP5 yake itaendelea hadi tarehe 30 Aprili.',
  'vip.help.9': 'Hifadhi/Shusha Kanuni',
  'vip.help.update.info': 'Mfumo wa vip umesasishwa, toleo lako ni la chini sana ili kuangalia vipengele vya hivi karibuni. Tafadhali sasisha hadi toleo jipya na furahia kazi mpya ya vip!',
  'vip.privileges.activate': 'VIP{N} Washa',
  'vip.privileges.label.avatar': 'Mfano wa kipekee wa kuonyesha utambulisho wako.',
  'vip.privileges.label.blockMessages': 'Zuia ujumbe wa wageni na uendelee kuwa na amani.',
  'vip.privileges.label.broadcast': 'Unapofikia VIP8 na zaidi, sasisho litazindua arifa ya programu.',
  'vip.privileges.label.bubble': 'Povu la mazungumzo la kipekee linafanya hotuba yako iwe na mvuto.',
  'vip.privileges.label.exclusivevehicles': 'Boresha mabadiliko yako ya kipekee. Unapofikia VIP11, tafadhali wasiliana na Huduma kwa Wateja ili kupata Gari la Kimeundwa, kila mtumiaji ana nafasi moja tu ya kuboresha.',
  'vip.privileges.label.follower': 'Unaweza kuwa VIP na kuongeza marafiki zaidi. Wasio VIP wanaweza kufuata watu 1000. VIP1-3 wataongeza 1000 kila mmoja, VIP4-6 wataongeza 2000 kila mmoja, VIP7 na zaidi wataongeza 3000 kila mmoja.',
  'vip.privileges.label.gif': 'Boresha fremu yako ya kipekee ya dinamik. Unapofikia VIP9, tafadhali wasiliana na Huduma kwa Wateja ili kupata Fremu ya Dinamik iliyobinafsishwa, kila mtumiaji ana nafasi moja tu ya kubinafsisha.',
  'vip.privileges.label.gift': 'Binafsisha zawadi yako ya kipekee. Unapofikia VIP10, tafadhali wasiliana na Huduma kwa Wateja ili kupata Zawadi zilizobinafsishwa, kila mtumiaji ana nafasi moja tu ya kubinafsisha.',
  'vip.privileges.label.icon': 'Lebo ya kipekee ya VIP, utambulisho wa kipekee wa watumiaji wa VIP, inaonyesha heshima yako.',
  'vip.privileges.label.id': 'Pata kitambulisho chako cha kipekee na wacha wengine wakukumbuke mara moja! VIP8: ABABAB (A na B zinapaswa kuwa tofauti) VIP9: AAABB (A na B zinapaswa kuwa tofauti) VIP10: ABAB (A na B zinapaswa kuwa tofauti) VIP11: AABB (A na B zinapaswa kuwa tofauti) Fomu zote hazipaswi kuanza na 0. Unahitaji kuwasiliana na huduma kwa wateja wa VIP ili kupata kitambulisho cha kipekee.',
  'vip.privileges.label.invisible': 'Baki kuwa usionekane na ujifiche katika mapendekezo ya wengine.',
  'vip.privileges.label.list': 'Kuweka kipaumbele katika kuonyesha matokeo ya utafutaji.',
  'vip.privileges.label.message': 'Unaweza kuweka mazungumzo ya watumiaji wengine juu ya orodha ya ujumbe.',
  'vip.privileges.label.name': 'Watumiaji watapata athari maalum za kupamba jina la mtumiaji.',
  'vip.privileges.label.open': 'Wengine wanaweza kukuona moja kwa moja mara tu unapofungua programu, utukufu usio na kifani! Unapofikia VIP12, tafadhali wasiliana na Huduma kwa Wateja ili upate Ukurasa wa Kifaa wa Masaa 24, kila mtumiaji ana nafasi moja tu ya kubinafsisha.',
  'vip.privileges.label.picture': 'Chaguo la kutuma picha kwenye gumzo la bullet.',
  'vip.privileges.label.privacy': 'Wengine hawawezi kutafuta chumba chako cha sauti.',
  'vip.privileges.label.protection': 'Usijali kuhusu kuondolewa kwenye kipaza sauti au chumba chochote.',
  'vip.privileges.label.rank': 'Unaweza kuwasha kitufe cha [Ficha Utambulisho] ili kuonekana kama mtu wa siri katika viwango.',
  'vip.privileges.label.room': 'Kadi ya chumba maalum cha VIP',
  'vip.privileges.label.sign': 'VIP wanaweza kudai zawadi za kujiandikisha mara mbili.',
  'vip.privileges.label.stealth': 'Unapowatembelea watumiaji wengine, hakuna historia itakayorekodiwa.',
  'vip.privileges.label.vehicle': 'Vikundi vya magari ya VIP pekee',
  'vip.privileges.label.visitor': 'Tazama alama zote za wageni ili usikose mtu yeyote anayejiunga na mashabiki.',
  'vip.privileges.stealth.close': 'Funga',
  'vip.privileges.stealth.open': 'Fungua',
  'vip.privileges.stealth.text': 'Ficha historia yangu ya ufikiaji',
  'vip.privileges.title': 'VIP Faida',
  'vip.privileges.title.avatar': 'Msingi wa VIP',
  'vip.privileges.title.blockMessages': 'Modi ya Kimya',
  'vip.privileges.title.broadcast': 'Arifa ya Programu',
  'vip.privileges.title.bubble': 'Bubble ya Gumzo la VIP',
  'vip.privileges.title.exclusivevehicles': 'Gari lililotengenezwa maalum',
  'vip.privileges.title.follower': 'Mpaka Juu wa Juu.',
  'vip.privileges.title.gif': 'Msururu wa Kijani Unaobadilika',
  'vip.privileges.title.gift': 'Zawadi za Kijalibishi',
  'vip.privileges.title.icon': 'Lebo ya VIP',
  'vip.privileges.title.id': 'Kitambulisho Maalum',
  'vip.privileges.title.invisible': 'Mode ya Kuonekana Bila Kuonekana',
  'vip.privileges.title.list': 'Onyesho la Kipaumbele',
  'vip.privileges.title.message': 'Orodha ya Ujumbe Mkuu',
  'vip.privileges.title.name': 'Jina la mtumiaji la kuangaziwa',
  'vip.privileges.title.open': 'Ukurasa wa Wazi Uliobinafsishwa',
  'vip.privileges.title.picture': 'Kadi ndogo ya kipekee kuonyesha heshima yako.',
  'vip.privileges.title.privacy': 'Usalama wa Faragha',
  'vip.privileges.title.protection': 'Zuia Kuondolewa',
  'vip.privileges.title.rank': 'Ficha Kitambulisho',
  'vip.privileges.title.room': 'Kadi ya Mini VIP',
  'vip.privileges.title.sign': 'Tuzo za Kuangalia VIP',
  'vip.privileges.title.stealth': 'Kikundi Kisichoonekana',
  'vip.privileges.title.vehicle': 'Gari la VIP',
  'vip.privileges.title.visitor': 'Alama za Kutembelea',
  'vip.privileges.update.info': 'Mfumo wa vip umesasishwa, toleo lako ni dogo sana ili kuona vipengele vya hivi karibuni. Tafadhali sasisha hadi toleo jipya na ufurahie kazi mpya ya vip!',
  'vip_introduce_1': '1.Nini maana ya VIP',
  'vip_introduce_2': '2.Jinsi ya kuwa VIP',
  'vip_introduce_3': '3. muda wa uhalali wa VIP',
  'vip_introduce_4': '4. Matumizi ya vifaa vya VIP',
  'vip_introduce_text1': 'VIP ni mfumo wa ukuaji wa watumiaji. Hivi sasa kuna ngazi 16, VIP1-VIP16. Kadri kiwango cha VIP kinavyopanda, ndivyo unavyonufaika zaidi na haki na mali zinazopatikana.',
  'vip_introduce_text2': 'Unaweza kupata pointi za uzoefu za VIP kwa kuongeza sarafu za dhahabu, sarafu 1 ya dhahabu = pointi 1 za uzoefu. Kadri unavyoongeza sarafu za dhahabu, ndivyo unavyopata pointi zaidi za uzoefu, na VIP itapaa hadi kiwango cha juu zaidi.',
  'vip_introduce_text3': 'Mara tu hadhi ya VIP inapopatikana, inakuwa halali milele na pointi za uzoefu za VIP zinakusanywa milele na hazitafuta. Kadri pointi za uzoefu zinavyoongezeka, utapandishwa ngazi hadi kiwango cha juu cha VIP na kufurahia faida zaidi za kiwango hicho.',
  'vip_introduce_text4': 'Vitu vya kiwango cha VIP unavyopata vitahifadhiwa daima katika begi lako na vinaweza kuvaliwa wakati wowote. Unaposasisha, vitu vya kiwango cha chini uliyovipata bado vinaweza kutumika.',
  'vip_introduce_title': 'Utangulizi wa sheria za VIP',
  'vip_introduce_welcome': 'Karibu kuwa VIP! VIP itakuruhusu kufurahia faida zaidi. Ifuatayo ni utangulizi wa msaada kuhusu VIP:',
  'vip_table1': 'Kiwango cha VIP',
  'voiceChat': 'User Ratings <br /> kwa ajili ya Mazungumzo ya Sauti na kipande',
  'voiceChat1': 'Ratings za Mtumiaji <br /> kwa Mazungumzo ya Sauti nami',
  'withdraw_text_0': 'Mapato',
  'withdraw_text_1': 'Usawa',
  'withdraw_text_10': 'Almasi:',
  'withdraw_text_11': 'Ratiba:',
  'withdraw_text_12': 'Chini ya mapitio',
  'withdraw_text_13': 'Withdraw kwa mafanikio',
  'withdraw_text_14': 'Uondoaji umeshindikana',
  'withdraw_text_15': 'Sababu ya kushindwa',
  'withdraw_text_16': 'Onyesha rekodi kutoka miezi mitatu iliyopita tu.',
  'withdraw_text_2': 'Ondoa',
  'withdraw_text_21': 'Kiasi cha Kutoa',
  'withdraw_text_22': 'Almasi zilizokatwa',
  'withdraw_text_23': 'Njia ya malipo:',
  'withdraw_text_24': 'Ongeza njia ya malipo',
  'withdraw_text_25': 'Toa mara moja',
  'withdraw_text_26': 'Tafadhali thibitisha taarifa sahihi za malipo. Taarifa zisizo sahihi zitasababisha kushindwa kwa kutoa fedha, na ada za ziada zitabebwa na mtumiaji.',
  'withdraw_text_27': 'Swali la maoni',
  'withdraw_text_28': 'Wasiliana na Huduma kwa Wateja',
  'withdraw_text_29': 'Vidokezo:',
  'withdraw_text_3': 'Badilisha',
  'withdraw_text_30': '1. Kutoa pesa kunaruhusiwa mara moja tu kwa siku.',
  'withdraw_text_31': 'Unapaswa kukamilisha uthibitisho wa mtu halisi na kuunganisha njia ya malipo kabla ya kuweza kuanzisha kutoa fedha.',
  'withdraw_text_32': '3. Jukwaa halitozi ada yoyote. Ada ya huduma inakatwa na kituo. Ada za huduma ni tofauti kwa vituo tofauti. Tafadhali wasiliana na huduma kwa wateja wa kituo kwa maelezo zaidi.',
  'withdraw_text_33': '4. Maendeleo ya kutoa pesa yanaweza kuonekana kupitia \'Rekodi ya Uondoaji\'',
  'withdraw_text_34': '5. Ikiwa kutoa fedha kutashindikana, almasi zitarudishwa.',
  'withdraw_text_35': 'Maombi ya uondoaji yatashughulikiwa ndani ya siku 7-14 za kazi (ongezeko wakati wa likizo).',
  'withdraw_text_36': 'Lazima ikamilishwe',
  'withdraw_text_37': '1. Uthibitishaji wa mtu halisi',
  'withdraw_text_38': '2. Ongeza njia ya malipo',
  'withdraw_text_39': 'Funga',
  'withdraw_text_4': 'Rekodi za withdrawals',
  'withdraw_text_40': 'Angalia',
  'withdraw_text_42': 'Hakuna njia ya malipo inayoungwa mkono',
  'withdraw_text_43': 'Kuna maagizo yasiyokamilika kwa njia hii ya malipo na hayawezi kubadilishwa au kufutwa kwa muda.',
  'withdraw_text_44': 'Imewasilishwa kwa mafanikio!',
  'withdraw_text_45': 'Wakati wa kuwasilisha',
  'withdraw_text_46': 'Itafika kwenye akaunti yako ndani ya siku 5 za kazi. Maendeleo maalum yanaweza kuangaliwa katika rekodi ya kutoa.',
  'withdraw_text_47': 'Kamilisha',
  'withdraw_text_48': 'Njia ya malipo',
  'withdraw_text_5': 'Hali ya kutosha ya almasi',
  'withdraw_text_59': 'Sasisha',
  'withdraw_text_6': 'Pata almasi zaidi',
  'withdraw_text_7': 'Nambari ya agizo:',
  'withdraw_text_8': 'Kipanga:',
  'withdraw_text_9': 'Kiasi:',
  'world.cup.records': 'Rekodi',
  'world.cup.time': 'Wakati',
  'About Us': 'Kuhusu Sisi',
  'Contact Us': 'Tufikie',
  'Intellectual Property Rights': 'Haki za Miliki ya Kiwanda',
  'Return Policy': 'Sera ya Kurudi',
  'Supported Payment Methods': 'Njia za Malipo Zinazoungwa Mkono',
  'about.title': 'Kuhusu',
  'chat': 'Chat',
  'check': 'Nenosiri lazima liwe na tarakimu 8 na herufi kubwa na ndogo.',
  'contact': 'Wasiliana',
  'contact.placeholder': 'Acha taarifa zako za mawasiliano hapa [Kik Confidential]',
  'contacts.email': 'Barua pepe',
  'contacts.phone': 'Simu',
  'contacts.title': 'Jinsi ya kuwasiliana nawe',
  'contacts.whatsapp': 'WhatsApp',
  'copied': 'kopya',
  'country.select.all': 'Yote',
  'country.select.hot': 'Moto',
  'details.placeholder': 'Tafadhali eleza maelezo ya shida yako.',
  'feedback.details': 'Maelezo',
  'feedback.screenshot': 'Picha ya skrini (Hiari)',
  'feedback.title': 'Mrejesho',
  'home.download': 'Pakua',
  'home.recharge': 'Rekaji',
  'home.slogan': 'Kutana na mwenza wako hapa<br />Daima pamoja nawe',
  'id': 'SOYO ID',
  'income.rules.chat': 'Wasiliana na Huduma kwa Wateja',
  'income.rules.diamonds': 'Almasi',
  'income.rules.important': 'Msisitizo:',
  'income.rules.rules.1': '1. Sheria za Mishahara: tarehe 16 ya kila mwezi na tarehe 1 ya mwezi unaofuata saa 00:00 zitakatwa kutoka kwenye salio la akaunti ya diamond.',
  'income.rules.rules.2': '2. Uwiano wa Malipo: 1USD=0 almasi',
  'income.rules.rules.3': '3. Wakati wa Malipo: ① tarehe 16 ya kila mwezi saa 00:00 ② tarehe ya kwanza ya mwezi unaofuata saa 00:00',
  'income.rules.rules.4': '4. Kipindi cha Malipo: Siku za kazi 7~14 (siku za likizo zimeahirishwa)',
  'income.rules.rules.extra': 'Tutakutaarifu kupitia \"Tim\" wakati mshahara utakapokuwa umekamilika. Maelezo ya punguzo la almasi yanaweza kuangaliwa katika \"Mapato\", tafadhali zingatia arifa za Tim. Malipo ya kawaida yatakamilika ndani ya siku za kazi 7-14, ikiwa kuna likizo, kipindi cha kuachiliwa na benki kitacheleweshwa, tafadhali kuwa na subira na subiri malipo. Ikiwa una maswali yoyote, tafadhali wasiliana na Huduma kwa Wateja, asante kwa msaada wako!',
  'income.rules.title': 'Sheria za Mishahara',
  'income.rules.usd': 'USD',
  'recharge.result.app_not_installed': 'Sofia haijasanidiwa',
  'recharge.result.download_app_tip': 'Tafadhali pakua na usakinishe programu ili kuendelea.',
  'recharge.result.error': 'Malipo Yamefaili',
  'recharge.result.jumping_to_app': 'Inaruka hadi Programu...',
  'recharge.result.success': 'Mafanikio ya Malipo',
  'report.details': 'Maelezo',
  'report.details.placeholder': 'Eleza maelezo ya ripoti yako.',
  'report.option.Fraud': 'Ulaghai',
  'report.option.Illegal': 'Haramu',
  'report.option.Other': 'Mwingine',
  'report.option.Porn': 'Uasherati',
  'report.option.Spam': 'Spam',
  'report.option.Violence': 'Vikosi',
  'report.option.room': 'Sipendi hii.',
  'report.option.user': 'Sipendi mtumiaji.',
  'report.reason': 'Kategoria',
  'report.room': 'Ripoti',
  'report.screenshot': 'Picha ya skrini (Hiari)',
  'report.submit': 'Wasilisha',
  'report.submit.success': 'Imepokelewa kwa Mafanikio',
  'report.user': 'Ripoti Mtumiaji',
  'retirar.rules.chat': 'Wasiliana na Huduma kwa Wateja',
  'retirar.rules.important': 'Msisitizo:',
  'retirar.rules.rules.1': 'Kabla ya kutumia huduma ya kutoa pesa, unahitaji kuwasilisha taarifa halisi za utambulisho ili kuhakikisha usalama wa akaunti yako.',
  'retirar.rules.rules.2': '2. Tafadhali toa taarifa halisi za utambulisho, ambazo zitatumika kama msingi wa utambuzi na kuamua haki ya kutumia akaunti yako.',
  'retirar.rules.rules.3': '3. Taarifa za utambulisho unazowasilisha zitahifadhiwa kwa siri kabisa na hazitatumika kwa madhumuni mengine.',
  'retirar.rules.rules.extra': 'Tafadhali wasiliana na huduma kwa wateja ikiwa unahitaji kutumia huduma ya kutoa fedha na utoe taarifa zifuatazo:',
  'retirar.rules.rules.extra.1': '1) Jina halisi',
  'retirar.rules.rules.extra.2': '2) Nambari ya Whatsapp',
  'retirar.rules.rules.extra.3': '3) Nyaraka za utambulisho (kadi za utambulisho, pasipoti, nk.)',
  'retirar.rules.rules.extra.4': '4) Njia yako ya malipo (BankTransfer, Payoneer, Fawry, nk.)',
  'retirar.rules.title': 'Kanuni za Uondoaji',
  'right': 'Timu ya SOYO ina haki ya tafsiri ya mwisho.',
  'same': 'Tafadhali ingiza nenosiri sawa.',
  'subTitle': 'Usiweke imani kwenye njia nyingine za kujaza zaidi ya wauzaji walioidhinishwa.',
  'submit.btn': 'Wasilisha',
  'submit.success': 'Asante kwa maoni yako',
  'terms.bug': 'Kukosea',
  'terms.help': 'Tatizo la Programu',
  'terms.suggestions': 'Mapendekezo',
  'terms.title': 'Jamii',
  'whatsapp': 'WhatsApp',
  'family_text_116': 'Pendekeza',
  'family_text_117': 'Nafasi',
  'family_text_97': 'Leo',
  'family_text_98': 'Kila Mwezi',
  'family_text_108': 'Jana',
  'family_text_69': 'Mwezi Uliopita',
  'family_text_95': 'Maarufu',
  'family_text_96': 'Mpya',
  'family_text_68': 'Mwezi Huu',
  'family_toast_03': 'Jiunge',
  'family_toast_04': 'Inakaguliwa',
  'family_toast_05': 'Imefanikiwa Kujiunga Na Familia.',
  'family_toast_02': 'Ombi Limewasilishwa, Tafadhali Subiri Idhini.',
  'family_toast_08': 'Unda Familia',
  'family_enter': 'Familia',
  'specialoffer_9': 'Ofa maalum',
  'specialoffer_10': 'Sarafu {%s}',
  'rewardboost_24': 'Hakuna Ofa Maalum inayopatikana.',
  'Noble_Change_5_METR': 'Mfano: Ikiwa kwa sasa wewe ni Viscount (499950 sarafu/mwezi), ukiwa na siku 13 zilizobaki, na unununua Count (999950sarafu/mwezi) leo, basi baada ya malipo, kipindi cha uhalali wa Count kitakuwa 13 * (499950/999950) + 30 = 6.5 imekatwa + 30 = siku 36.',
  'Noble_Change_5_TR': 'Mfano: Ikiwa kwa sasa wewe ni Viscount (499950 sarafu/mwezi), ukiwa na siku 13 zilizobaki, na unununua Count (999950sarafu/mwezi) leo, basi baada ya malipo, kipindi cha uhalali wa Count kitakuwa 13 * (599950/999950) + 30 = 6.5 imekatwa + 30 = siku 36.',
  'Noble_Change_5_ME': 'Mfano: Ikiwa kwa sasa wewe ni Viscount (999900 sarafu/mwezi), ukiwa na siku 13 zilizobaki, na unununua Count (1999900sarafu/mwezi) leo, basi baada ya malipo, kipindi cha uhalali wa Count kitakuwa 13 * (999900/1999900) + 30 = 6.5 imekatwa + 30 = siku 36.',
  'lucky.packet.7_TR': '3. Kiasi cha kila mtu (kiasi cha sarafu/idadi ya watu) kinahitaji kuwa zaidi ya au sawa na sarafu 5.',
  'lucky.packet.7_ME': '3. Kiasi cha kila mtu (kiasi cha sarafu/idadi ya watu) kinahitaji kuwa zaidi ya au sawa na sarafu 10.',
  'lucky.packet.8_TR': '4. Wakati kiasi cha pakiti kinapokuwa zaidi ya sarafu 50000 na idadi ya watu ikiwa zaidi ya 10, itasababisha arifa ya ulimwengu, na ikoni maalum itaonyeshwa kwenye orodha ya chumba.',
  'lucky.packet.8_ME': '4. Wakati kiasi cha pakiti kinapokuwa zaidi ya sarafu 100000 na idadi ya watu ikiwa zaidi ya 10, itasababisha arifa ya ulimwengu, na ikoni maalum itaonyeshwa kwenye orodha ya chumba.',
};

export default SW;
